import { useEffect, useRef, useState } from "react";
import { Alert, Button, Dropdown, Form, Modal, Spinner, Tab, Tabs, Toast, ToastContainer } from "react-bootstrap";
import { Draggable } from "react-drag-reorder";
import { Rating } from "@mui/material";
import { useSelector } from "react-redux";

import { deleteApi, getApi, postApi } from "../../../shared/services/apiHelper";
import { aiQuestionGenerate, assessmentAdd, assessmentDelete, assessmentDetail, programmeList, subjectList } from "../../../shared/settings/apiConfig";
import { DropdownInput, DropdownInputGroup, MenuItemInput, TextAreaInput, TextInput } from "../../../shared/form/FormInput";
import { uploadLargetAsset } from "../../../utils/utils";

import StarIcon from '@mui/icons-material/Star';
import './AssessmentAdd.scss';
import { ROLE } from "../../../shared/settings/config";
import { Validators } from "../../../shared/utils/Validators";
import ReactQuillEditor from "../../../shared/form/ReactQuilEditor";
import ReactQuill from "react-quill-new";
import { programmingLanguages } from "../../../shared/utils/constants";

const complexity = [
    {
        id: "Level 1",
        value: "Level 1"
    },
    {
        id: "Level 2",
        value: "Level 2"
    },
    {
        id: "Level 3",
        value: "Level 3"
    },
    {
        id: "Level 4",
        value: "Level 4"
    }
];

const scoringCredit = [
    {
        id: 1,
        value: "Score"
    },
    {
        id: 2,
        value: "Weightage"
    },
    {
        id: 3,
        value: "Question"
    }
];

const scoringCreditForDefaultSummary = [
    {
        id: 1,
        value: "Score"
    }
];

const operators = [
    {
        id: "==",
        value: "=="
    },
    {
        id: ">",
        value: ">"
    },
    {
        id: "<",
        value: "<"
    },
    {
        id: ">=",
        value: ">="
    },
    {
        id: "<=",
        value: "<="
    }
];

const operatorsWithNames = [
    {
        id: "==",
        value: "Equal To"
    },
    {
        id: ">",
        value: "Greater Than"
    },
    {
        id: "<",
        value: "Lesser Than"
    },
    {
        id: ">=",
        value: "Greater Than Or Equal To"
    },
    {
        id: "<=",
        value: "Lesser Than Or Equal To"
    },
    {
        id: "<>",
        value: "Between"
    }
];

const linkType = [
    {
        id: "When the choice/answer is",
        value: "When the choice/answer is",
    },
    {
        id: "Always",
        value: "Always",
    },
];

const questionlinkType = [
    {
        id: "Goto question",
        value: "Goto question",
    },
    {
        id: "End the assessment",
        value: "End the assessment",
    },
];

const questionTypes = [

    {
        id: 1,
        value: "Multi Choice",
    },
    {
        id: 2,
        value: "True or False",
    },
    {
        id: 3,
        value: "Descriptive",
    },
    {
        id: 4,
        value: "Rating Based",
    },
    // {
    //     id: 5,
    //     value: "Reorder",
    // }
    {
        id: 6,
        value: "Graphical Submission"
    },
    {
        id: 7,
        value: "Coding and Programming Language"
    }
];

const aiQuestionTypes = [

    {
        id: 1,
        value: "Multi Choice",
    },
    {
        id: 2,
        value: "True or False",
    },
    {
        id: 3,
        value: "Descriptive",
    }
];

const noOptions = [3, 4, 5, 6, 7];

const questionMore = {
    icon: <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/menudots.png`} />,
    items: [
        {
            id: 1,
            key: 'mandatory',
            label: 'Mandatory / Cannot Skip',
            type: 'check'
        },
        // {
        //     id: 2,
        //     key: 'timedquestion',
        //     label: 'Timed Question',
        //     type: 'check',
        //     children: [
        //         {
        //             id: 2.1,
        //             key: 'timedquestionmins',
        //             label: 'Mins',
        //             type: 'number'
        //         },
        //         {
        //             id: 2.2,
        //             key: 'timedquestionsecs',
        //             label: 'Sec',
        //             type: 'number'
        //         }
        //     ]
        // },
        // {
        //     id: 3,
        //     key: 'endassessment',
        //     label: 'End assessment',
        //     type: 'check'
        // },
        // {
        //     id: 4,
        //     key: 'randomizeoptions',
        //     label: 'Randomize Options',
        //     type: 'check'
        // },
        {
            id: 5,
            key: 'allowattachments',
            label: 'Allow Attachments',
            type: 'check'
        },
        // {
        //     id: 6,
        //     key: 'negativemarking',
        //     label: 'Add Negative Marking / Penality',
        //     type: 'check',
        //     children: [
        //         {
        //             id: 6.1,
        //             key: 'negativemarkingscore',
        //             label: 'Score',
        //             type: 'number'
        //         }
        //     ]
        // },
        // {
        //     id: 7,
        //     key: 'incentive',
        //     label: 'Add Incentive / Score',
        //     type: 'check',
        //     children: [
        //         {
        //             id: 7.1,
        //             key: 'incentivescore',
        //             label: 'Score',
        //             type: 'number'
        //         }
        //     ]
        // }
    ]
};

const questionClone = {
    icon: <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/clone.png`} />,
    items: [
        {
            id: 8,
            label: 'Duplicate Question Only',
            type: 'menu'
        },
        {
            id: 9,
            label: 'Duplicate with Answers',
            type: 'menu'
        }
    ]
};


const getDefaultConfigurationData = (operator, scoreMin, scoreMax, description, indicatorname) => {
    return {
        operator: { value: operator, error: "", validators: [Validators.required()] },
        scoremin: { value: scoreMin, error: "", validators: [Validators.required()] },
        scoremax: { value: scoreMax, error: "", validators: [] },
        description: { value: description, error: "", validators: [Validators.required()] },
        indicatorname: { value: indicatorname, error: "", validators: [Validators.required()] },
    };
};

const getDefaultKpiData = (indicatorName) => {
    return {
        indicatorname: { value: indicatorName, error: "", validators: [Validators.required()] },
        configuration: [getDefaultKpiConfigurationData('', '', '', '')]
    }
};

const getDefaultKpiConfigurationData = (operator, scoreMin, scoreMax, displayName, color = '#000000') => {
    return {
        operator: { value: operator, error: "", validators: [Validators.required()] },
        scoremin: { value: scoreMin, error: "", validators: [Validators.required()] },
        scoremax: { value: scoreMax, error: "", validators: [] },
        displayname: { value: displayName, error: "", validators: [Validators.required()] },
        color: { value: color, error: "", validators: [] }
    };
};

export const AssessmentAddFn = (props) => {

    const validateQuestionTypeToGetOptionSet = (questionType, existingOptionSet = []) => {
        if (questionType) {
            if (noOptions.includes(questionType)) {
                return [];
            } else if (Array.isArray(existingOptionSet)) { // Adding a default answer set if there is no option set
                if (existingOptionSet.length > 0) {
                    let arr = []
                    existingOptionSet.map((data, index) => {
                        arr.push(getDefaultOptionSetData(data?.isdefaultset, index + 1, data?.options))
                    })
                    return (arr)

                }
                return ([getDefaultOptionSetData(true)])
                // return existingOptionSet.length > 0 ? existingOptionSet : [getDefaultOptionSetData(true)];
            }
        }

        return [getDefaultOptionSetData(true)];
    };

    const getDefaultQuestionData = (questionName, hint, questionType, questionOrder, questionUniqueId = null, questionScore=null, ratingType = null, questionMandatory = false, timedQuestion = false, timedQuestionMins = null, timedQuestionSecs = null, endAssessment = false, randomizeOptions = false, allowAttachments = false, addNegativeMarking = false, negativeMarkingScore = null, addIncentive = false, incentiveScore = null, optionSetData = [],assets=[], programmingLanguage = null) => {
        let setData = validateQuestionTypeToGetOptionSet(questionType, optionSetData);
        return {
            questionname: { value: questionName, error: "", validators: [Validators.required()] },
            hint: hint,
            questiontype: { value: questionType, error: "", validators: [Validators.required()] },
            ratingtype: ratingType,
            mandatory: questionMandatory,
            timedquestion: timedQuestion,
            timedquestionmins: timedQuestionMins,
            timedquestionsecs: timedQuestionSecs,
            negativemarkingscore: negativeMarkingScore,
            incentivescore: incentiveScore,
            endassessment: endAssessment,
            randomizeoptions: randomizeOptions,
            allowattachments: allowAttachments,
            negativemarking: addNegativeMarking,
            incentive: addIncentive,
            questionorder: questionOrder,
            questionuniqueid: questionUniqueId ? questionUniqueId : `q-${Date.now()}`,
            questionscore: questionScore,
            optionset: setData,
            assets: assets,
            programminglanguage: programmingLanguage
        };
    };

    const getDefaultImageData = (name, type, size, file, url) => {
        return { name, type, size, file, url };
    };

    const getDefaultOptionData = (optionName, score) => {
        return {
            optionname: { value: optionName, error: "", validators: [Validators.required()] },
            score: { value: score, error: "", validators: [] }
        };
    };

    const getDefaultOptionSetData = (isDefaultSet = false, optionSetLength = null, options = []) => {
        if (options?.length > 0) {
            options = options.map((data, index) => {
                return (getDefaultOptionData(data?.optionname, data?.score))
            })
        } else {
            options = [getDefaultOptionData("", "")]
        }
        return { isdefaultset: isDefaultSet, options: options, setnumber: optionSetLength || 1 };
    };

    const getDefaultSummaryData = (summaryName, basedOn, isOverallSummary, isDefaultSummary = false, sectionId = null) => {
        let data = {
            summaryname: { value: summaryName, error: "", validators: [Validators.required()] },
            basedon: { value: basedOn, error: "", validators: [Validators.required()] },
            sectionid: sectionId,
            isoverallsummary: isOverallSummary,
            isdefaultsummary: isDefaultSummary
        };
        if (isOverallSummary) {
            if (isDefaultSummary) {
                data['defaultconfiguration'] = [getDefaultConfigurationData('', '', '', '', '')];
            } else {
                data['kpi'] = [getDefaultKpiData('')];
                data['questions'] = sections?.map(section => {
                    return {
                        name: section?.sectionname?.value,
                        options: section?.questions?.map(question => {
                            return { id: question.questionuniqueid, value: question.questionname?.value, questionname: question.questionname?.value, questionuniqueid: question.questionuniqueid };
                        })
                    }
                });
            }
        } else {
            data['questions'] = [
                {
                    name: sections[sectionId]?.sectionname?.value,
                    options: sections[sectionId]?.questions?.map(question => {
                        return { id: question.questionuniqueid, value: question.questionname?.value, questionname: question.questionname?.value, questionuniqueid: question.questionuniqueid };
                    })
                }
            ];
        }
        return data;
    };

    const defaultSection = (index = 1) => {
        return ({
            sectionname: { value: `Section ${index}`, error: "", validators: [Validators.required()] },
            sectionsummary: { value: "", error: "", validators: [] },
            questions: [getDefaultQuestionData('', '', '', 1)]
        })
    };

    const loggedInUserData = useSelector((state) => { return state.user });

    const [loading, setloading] = useState(false)
    const [assessmentData, setAssessmentData] = useState({
        assessmentname: { value: "", error: "", validators: [Validators.required()] },
        subtitle: { value: "", error: "", validators: [] },
        programmeid: { value: "", error: "", validators: [Validators.required()] },
        subjectid: { value: "", error: "", validators: [Validators.required()] },
        complexity: { value: "", error: "", validators: [Validators.required()] },
        scoreparameter: { value: 1, error: "", validators: [] },
        version: 1,
        settings: {}
    });
    const [sectionIndex, setsectionIndex] = useState(0);
    const [questionIndex, setquestionIndex] = useState(0);
    const [programmeListData, setProgrammeListData] = useState([]);
    const [subjectListData, setSubjectListData] = useState([]);
    const [sections, setSections] = useState([]);
    const [summary, setSummary] = useState([]);

    const [constModal, setConstModal] = useState({ show: false, data: {} });
    const [apiError, setApiError] = useState("");
    const [assessmentLoading, setassessmentLoading] = useState(true);
    const [alert, setalert] = useState({ variant: "info", message: "" })

    const [title, settitle] = useState("") // TODO header name has to be moved to a HeaderHOC.

    const scrollRef = useRef(null);
    const [isAtTop, setIsAtTop] = useState(true);
    const [isAtBottom, setIsAtBottom] = useState(false);
    const scrollContainerRef = useRef(null); // Reference to scrollable div

    const [attachedImage, setAttachedImage] = useState(null);
    const [disableSave, setDisableSave] = useState(false);

    const quillRef = useRef([]);

    useEffect(() => {
     if(apiError != "") {
        setTimeout(() => {
            setApiError("")
        }, 5000);
     }
    }, [apiError])

    useEffect(() => {
        const hasInvalidGraphical = sections.some(section =>
            section.questions.some(q =>
            q.questiontype.value == 6 && (!q.assets || q.assets.length === 0)
            )
        );
        setDisableSave(hasInvalidGraphical);
    }, [sections]);
        
    useEffect(() => {
        const handleScroll = () => {
            if (scrollContainerRef.current) {
                const container = scrollContainerRef.current;
                const scrollTop = container.scrollTop;
                const scrollHeight = container.scrollHeight;
                const clientHeight = container.clientHeight;

                setIsAtTop(scrollTop === 0);
                setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 10);
            }
        };

        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    const scrollToTop = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const scrollToBottom = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: scrollContainerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    };
    const setAlertMessage=(message,variant,calback)=>{
        setalert({ message, variant })
        setTimeout(() => {
            calback() 
            setalert({ message:"", variant:"" })
        }, 2000);
    }   
   
    useEffect(() => {
        Promise.all([getProgrammeList()]).then(responses => {
            setProgrammeListData(responses[0].map(elem => { return { ...elem, value: elem.programmename }; }));
            setassessmentLoading(false)
        }).catch(() => {
            setassessmentLoading(false)
        });
        try {
            if (props.location.pathname.includes('edit')) {
                settitle("");
                getApi(assessmentDetail + props.match.params.assessmentid).then((response) => {
                    const data = response.data.data;
                    getSubjectList(data.programmeid);
                    setAssessmentData({
                        assessmentname: { ...assessmentData?.assessmentname, value: data.assessmentname },
                        subtitle: { ...assessmentData?.subtitle, value: data.subtitle },
                        programmeid: { ...assessmentData?.programmeid, value: data.programmeid },
                        subjectid: { ...assessmentData?.subjectid, value: data.subjectid },
                        complexity: { ...assessmentData?.complexity, value: data.complexity },
                        parentid: data.id,
                        scoreparameter: { ...assessmentData?.scoreparameter, value: data.scoreparameter },
                        version: (data.version || 0) + 1,
                        settings: data.settings
                    });
                    let sectionData = []
                    JSON.parse(JSON.stringify(data?.sections))?.forEach(section => {
                        let questionList = []
                        section?.questions.forEach(question => {
                            questionList.push(getDefaultQuestionData(question.questionname, question.hint, parseInt(question.questiontype), question.questionorder, question.questionuniqueid, question?.questionscore, question?.questionuniqueid, question?.mandatory, question?.timedquestion, question?.timedquestionmins, question?.timedquestionsecs, question?.endassessment, question?.randomizeoptions, question?.allowattachments, question?.negativemarking, question?.negativemarkingscore, question?.incentive, question?.incentivescore, question?.optionset,question?.assets, question?.programminglanguage))
                        })
                        sectionData.push({
                            sectionname: { value: section?.sectionname, error: "", validators: [Validators.required()] },
                            sectionsummary: { value: section?.sectionsummary, error: "", validators: [] },
                            questions: questionList
                        })
    
                    })
                    setSections([...sectionData])
                    let summaryData = [...JSON.parse(JSON.stringify(data.summary))]
                    summaryData =  summaryData.map((summaryElem, sumInx) => {
                        // summaryElem = {
                        //     ...summaryElem,
                        // ...getDefaultSummaryData(summaryElem?.summaryname, summaryElem?.basedon, false, false, summaryElem?.sectionid)
                        // }
                        summaryElem = {
                            ...summaryElem,
                            summaryname: { value: summaryElem?.summaryname, error: "", validators: [Validators.required()] },
                            basedon: { value: summaryElem?.basedon, error: "", validators: [Validators.required()] },
                            sectionid: summaryElem?.sectionid,
                        }
                        if (summaryElem?.isoverallsummary) {
                            if (summaryElem?.isdefaultsummary) {
                                summaryElem["defaultconfiguration"] = summaryElem['defaultconfiguration']?.map(defaultconfiguration => {
                                    let defaultconfig = getDefaultConfigurationData(defaultconfiguration?.operator, defaultconfiguration?.scoremin, defaultconfiguration?.scoremax, defaultconfiguration?.description, defaultconfiguration?.indicatorname)
                                    return (defaultconfig)
                                        
                                })
                            } else {
                                summaryElem['kpi'] =  summaryElem['kpi']?.map((kpi) => {
                                   let kpidata =  {
                                        indicatorname: { value: kpi?.indicatorname, error: "", validators: [Validators.required()] },
                                        configuration: kpi?.configuration.map((configuration) => {
                                            return (getDefaultKpiConfigurationData(configuration?.operator, configuration?.scoremin, configuration?.scoremax, configuration?.displayname, configuration?.color))
                                        })
                                    }
                                    return(kpidata )
                                })
                                summaryElem['questions'] = sectionData?.map(section => {
                                    return {
                                        name: section.sectionname?.value,
                                        options: section.questions?.map(question => {
                                            return { 
                                                id: question.questionuniqueid,
                                                 value: question.questionname?.value,
                                                  questionname: question.questionname?.value, 
                                                  questionuniqueid: question.questionuniqueid,
                                                  checked: summaryElem['questions']?.findIndex(i=>i?.questionuniqueid == question?.questionuniqueid) >=0
                                                };
                                        })
                                    }
                                });
                            }
                        } else {
                            summaryElem['questions'] = [
                                {
                                    name: sectionData[summaryElem?.sectionid].sectionname?.value,
                                    options: sectionData[summaryElem?.sectionid].questions?.map(question => {
                                        return {
                                            id: question.questionuniqueid,
                                            value: question.questionname?.value,
                                            questionname: question.questionname?.value,
                                            questionuniqueid: question.questionuniqueid,
                                            checked: summaryElem?.questions?.findIndex(elem => { return elem.questionuniqueid == question.questionuniqueid; }) > -1 ? true : false
                                        };
                                    })
                                }
                            ];
                        }
                        // if (summaryElem.isoverallsummary) {
                        //     if (!summaryElem.isdefaultsummary) {
                        //         summaryElem?.questions = data.sections?.map(section => {
                        //             return {
                        //                 name: section.sectionname?.value,
                        //                 options: section.questions?.map(question => {
                        //                     return {
                        //                         id: question.questionuniqueid,
                        //                         value: question.questionname,
                        //                         questionname: question.questionname,
                        //                         questionuniqueid: question.questionuniqueid,
                        //                         checked: summaryElem?.questions?.findIndex(elem => { return elem.questionuniqueid == question.questionuniqueid; }) > -1 ? true : false
                        //                     };
                        //                 })
                        //             }
                        //         });
                        //     }
                        // } else {
                        //     // TODO formatting for section level summary
                        // }
                        return(summaryElem)
                    });
                    setSummary(summaryData);
                });
            } else {
                settitle(props?.location?.state?.title);
                if (props?.location?.state?.aiGeneratedQuestions?.length > 0) {
                    let aiGeneratedQuestions = props.location.state.aiGeneratedQuestions;
                    let questions = [];
                    aiGeneratedQuestions.forEach(aiQuestion => {
                        questions.push(getDefaultQuestionData(aiQuestion.questionname, aiQuestion.hint, parseInt(aiQuestion.questiontype), aiQuestion.questionorder, aiQuestion.questionuniqueid,aiQuestion?.questionscore, null, false, false, null, null, false, false, false, false, null, false, null, aiQuestion.optionset));
                    });
                    setSections(
                        [{ ...defaultSection(1), questions }]
                    )
                } else {
                    setSections([defaultSection(1)])
                }
    
                setSummary([getDefaultSummaryData('Default Summary', scoringCreditForDefaultSummary[0].id, true, true)]);
            }
        } catch (error) {
            setloading(false)
        }

    }, []);

    const getSubjectList = (programmeId) => {
        let payload = {
            field: ["id", "subjectname"],
            filter: [
                {
                    field: "programmeid",
                    value: programmeId,
                    op: '=',
                    join: 'AND'
                }
            ]
        };
        postApi(subjectList, payload).then(response => {
            setSubjectListData(response.data.data.map(elem => { return { ...elem, value: elem.subjectname }; }));
        }).catch((error) => {
            setSubjectListData([]);
        });
    }
    const getProgrammeList = () => {
        let payload = {
            field: ["id", "programmename"],
            filter: []
        };

        if (loggedInUserData.roleid === ROLE.ASSESSOR) {
            payload.filter.push({
                field: 'departmentid',
                value: loggedInUserData.departmentid,
                op: '=',
                join: 'AND'
            });
        }

        return new Promise((resolve, reject) => {
            postApi(programmeList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }
    const summaryReset = (summary) => {
        let summaryData = JSON.parse(JSON.stringify(summary))
        summaryData?.map((summaryItem, sindex) => {
            summaryItem["summaryname"] ={...summaryItem["summaryname"],validators:summary[sindex]["summaryname"]?.validators}
            summaryItem["basedon"] ={...summaryItem["basedon"],validators:summary[sindex]["basedon"]?.validators}
            summaryItem['defaultconfiguration']?.map((config,cindex) => {

                config["operator"] = { ...config["operator"], validators: summary[sindex]["defaultconfiguration"][cindex]["operator"]?.validators }
                config["scoremin"] = { ...config["scoremin"], validators: summary[sindex]["defaultconfiguration"][cindex]["scoremin"]?.validators }
                config["description"] = { ...config["description"], validators: summary[sindex]["defaultconfiguration"][cindex]["description"]?.validators }
                config["indicatorname"] = { ...config["indicatorname"], validators: summary[sindex]["defaultconfiguration"][cindex]["indicatorname"]?.validators }
                config["scoremax"] = { ...config["scoremax"], validators: summary[sindex]["defaultconfiguration"][cindex]["scoremax"]?.validators }

            })
            summaryItem['kpi']?.map((kpi,kindex) => {
                kpi["indicatorname"] = { ...kpi["indicatorname"], validators: summary[sindex]["kpi"][kindex]["indicatorname"]?.validators }
                kpi['configuration']?.map((kpiconfig,kcindex) => {
                    kpiconfig["operator"] = { ...kpiconfig["operator"], validators: summary[sindex]["kpi"][kindex]["configuration"][kcindex]["operator"]?.validators }
                    kpiconfig["scoremin"] = { ...kpiconfig["scoremin"], validators: summary[sindex]["kpi"][kindex]["configuration"][kcindex]["scoremin"]?.validators }
                    kpiconfig["displayname"] = { ...kpiconfig["displayname"], validators: summary[sindex]["kpi"][kindex]["configuration"][kcindex]["displayname"]?.validators }
                    kpiconfig["color"] = { ...kpiconfig["color"], validators: summary[sindex]["kpi"][kindex]["configuration"][kcindex]["color"]?.validators }
                    kpiconfig["scoremax"] = { ...kpiconfig["scoremax"], validators: summary[sindex]["kpi"][kindex]["configuration"][kcindex]["scoremax"]?.validators }
                })
            })
        })
        return summaryData
    }
    const openSummaryModal = () => {
        // sections.forEach((element, index) => {
        //     if ( typeof summaryData[index + 1] === 'undefined' ) {
        //         summaryData.push(getDefaultSummaryData('', scoringCredit[0].id, false, index));
        //     }
        // });
        // if(Validators.validateAssessment(assessmentData, sections)?.formValid){
            setConstModal({
                show: true,
                data: {
                    name: "Summary",
                    summaryData: summaryReset(summary)
                }
            })
        // } else {
        //     setApiError(" please add the required fields in red above")
        // }
    };

    const addSection = () => {
        setSections(prevState => { return [...prevState, ...[{ ...defaultSection(prevState.length + 1) }]] });
    };

    const addQuestion = (sectionIndex) => {
        setSections((prevState) => {
            let questionList = prevState[sectionIndex].questions;
            questionList.push(getDefaultQuestionData('', '', '', questionList.length + 1));
            return [...prevState];
        });

        // Scrolling to the bottom when question is added
        if (scrollRef.current) {
            scrollRef.current.scrollTo({ behavior: 'smooth', top: scrollRef.current.scrollHeight });
        }
    };

    const duplicateQuestion = (sectionIndex, questionIndex, cloneWithAnswers = false) => {
        setSections((prevState) => {
            const questionUniqueId = `q-${Date.now()}`;
            let questionList = prevState[sectionIndex].questions;
            let question = { ...questionList[questionIndex] };

            let clonedAssets = [];
            if (Array.isArray(question['assets']) && question['assets'].length > 0) {
                question['assets'].forEach(asset => {
                    if (asset.id) {
                        clonedAssets.push({ ...asset });
                    } else {
                        clonedAssets.push({ ...asset, questionuniqueid: questionUniqueId, file: new File([asset.file], asset.file.name, { type: asset.file.type }) });
                    }
                });
            }
            question['questionuniqueid'] = questionUniqueId;
            question['assets'] = clonedAssets;
            let optionset = []
            if (cloneWithAnswers) {
                optionset = [...JSON.parse(JSON.stringify(question["optionset"]))]
                optionset = optionset.map((optionset) => {
                    optionset["options"] = [...optionset["options"]].map((option) => {
                        option["optionname"] = option["optionname"]?.value
                        option["score"] = option["score"]?.value
                        return (option)
                    })
                    return (optionset)
                })
            }
            question['optionset'] = validateQuestionTypeToGetOptionSet(question["questiontype"], optionset);

            questionList.push({ ...question });

            return [...prevState];
        });

    };

    const addOptionSet = (sectionIndex, qIndex) => {
        setSections((prevState) => {
            let optionSet = prevState[sectionIndex].questions[qIndex].optionset;
            optionSet.push(getDefaultOptionSetData(optionSet.length === 0 ? true : false, optionSet.length + 1));
            return [...prevState];
        });
    };

    const addOption = (sectionIndex, qIndex, opSetIndex) => {
        setSections((prevState) => {
            let options = prevState[sectionIndex].questions[qIndex].optionset[opSetIndex].options;
            options.push(getDefaultOptionData('', ''));
            return [...prevState];
        });
    };

    const deleteSet = (sectionIndex, qIndex, opSetIndex) => {
        setSections((prevState) => {
            prevState[sectionIndex].questions[qIndex].optionset.splice(opSetIndex, 1)
            return [...prevState];
        });
    };

    const deleteQuestion = (sectionIndex, qindex,ques) => {
        setConstModal({
            show: true,
            data: {
                name: "Delete Modal",
                delete: () => {
                    setSections((prevState) => {
                        prevState[sectionIndex].questions.splice(qindex, 1)
                        return [...prevState];
                    });
                },
                type:`Question`
            }
        })
       
    };

    const deleteSection = (sectionIndex) => {
        setConstModal({
            show: true,
            data: {
                name: "Delete Modal",
                delete: () => {
                    let section = [...sections]
                    section.splice(sectionIndex, 1)
                    setSections(section);
                },
                type:`Section`
            }
        })
    };

    const onChangeAssessmentData = (name, value) => {
        if (value.length === 1 && typeof value === "string" && value.startsWith(" ")) {
            return;
        }

        setAssessmentData(prevState => {
            return {
                ...prevState,
                [name]: Validators.validateFormControl(prevState[name], value),
            }
        });
        if (name === 'programmeid') {
            getSubjectList(value);
            setAssessmentData(prevState => {
                return {
                    ...prevState,
                    subjectid: { ...prevState["subjectid"], value: "" }
                }
            });
        }

        if ( name === 'scoreparameter' ) {
            if ( value == 1 ) {
                setSummary([getDefaultSummaryData('Default Summary', scoringCreditForDefaultSummary[0].id, true, true)]);
            } else {
                setSummary([]);
            }
        }
    };

    const onChangeSectionData = (sectionIndex, name, event) => {
        sections[sectionIndex][name] = Validators.validateFormControl(sections[sectionIndex][name], event.target.value)
        setSections(prevState => { return [...prevState]; });
    };

    const openMediaPicker = (name, sectionIndex, questionIndex) => {
        let input = document.createElement('input');
        input.type = 'file';

        input.onchange = event => {
            if (event.target.files?.length > 0) {
                onChangeQuestionData(name, event.target.files[0], sectionIndex, questionIndex);
            }
        }

        input.click();
    };

    const onChangeQuestionData = (name, value, sectionIndex, qIndex) => {

        if (name === 'questionname') {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = value;
            const textContent = tempDiv.innerText || tempDiv.textContent;
            if (textContent.length === 1 && textContent.startsWith(" ") || textContent.trim() === "") {
                return; // Block input if the first character is a space
            }
        }
    
        if(name === 'questionscore'){
            value = value.replace(/[^\d.]/g, '');
        }
        setSections(prevState => {
            let question = prevState[sectionIndex].questions[qIndex];
            if (question[name] != null && typeof question[name] === "object") {
                question[name] = Validators.validateFormControl(question[name], value)
                if (name === 'questiontype') {
                    if (question[name]?.value != 4) {
                        question['ratingtype'] = null;

                        const selectedType = typeof value === "object" ? value.id : value;

                        if (selectedType === 6) {
                            if (question?.assets?.length > 0) {
                                setAttachedImage(question.assets[0].url);
                            } else {
                                setConstModal({ show: true, data: { modalType: "Graphical", name, value, sectionIndex, qIndex } });
                                setAttachedImage(null);
                            }
                        }
                    }

                    question['programminglanguage'] = question[name]?.value == 7 ? programmingLanguages[0].id : null;
                    
                    // Removing optionset for the questions
                    question["optionset"] = question["optionset"].map((optionset) => {
                        optionset["options"] = optionset["options"].map((option) => {
                            option["optionname"] = option["optionname"]?.value
                            option["score"] = option["score"]?.value
                            return (option)
                        })
                        return (optionset)
                    })
                    if (question[name]?.value === 2) { 
                        question["optionset"] =  question["optionset"].map((opset=>{
                            if(opset?.options.length >= 2) {
                                return({
                                    ...opset,
                                    options: opset?.options.slice(0,2)
                                }) 
                            } else if(opset?.options.length == 1) {

                                return({
                                    ...opset,
                                    options: [ 
                                         ...opset?.options,
                                        {optionname:"",score:""}
                                    ]
                                      
                                       

                                }) 
                            }
                        }))
                    }
                    question['optionset'] = validateQuestionTypeToGetOptionSet(value, question["optionset"]);
                }
            }
            else if (name === "image") {
                question["assets"] = [getDefaultImageData(value.name, value.type, value.size, value, URL.createObjectURL(value))];
            } 
            else if (name == "graphicalImage") {
                setConstModal({ show: true, data: { modalType: "Graphical", name, value, sectionIndex, qIndex} });
                setAttachedImage(URL.createObjectURL(value));
            }
            else {
                question[name] = value;

                if (name === 'timedquestion' && !value) {
                    question['timedquestionmins'] = null;
                    question['timedquestionsecs'] = null;
                } else if (name === 'negativemarking' && !value) {
                    question['negativemarkingscore'] = null;
                } else if (name === 'incentive' && !value) {
                    question['incentivescore'] = null;
                }
            }
            return [...prevState];
        });
    };

    const onChangeOptionData = (name, value, sectionIndex, qIndex, opSetIndex, opIndex) => {
        if (value.length === 1 && typeof value === "string" &&  value.startsWith(" ")) {
            return;
        }
        if(name == 'score'){
            value =  value ? value.replace(/[^\d.]/g, '') : ''
        }
        if(name == "optionname"){
            if (value.length > 10) {
                value = value.slice(0, 100);
            }
           
        }
        setSections(prevState => {
            let option = prevState[sectionIndex].questions[qIndex].optionset[opSetIndex].options[opIndex]
            option[name] = Validators.validateFormControl(option[name], value)
            return [...prevState];
        });
    };
    const optionDelete = (sectionIndex, qIndex, opSetIndex, opIndex) => {
        setSections(prevState => {
            prevState[sectionIndex].questions[qIndex].optionset[opSetIndex].options.splice(opIndex, 1)

            return [...prevState];
        });
    }

    const onChangeAnswerSet = (sectionIndex, qIndex, opSetIndex, value) => {
        setSections(prevState => {
            prevState[sectionIndex].questions[qIndex].optionset.forEach((element, index) => {
                element['isdefaultset'] = index == opSetIndex ? value : false;
            });
            return [...prevState];
        });
    };

    const saveAssessment = async () => {
        setApiError("");
        let validData = Validators.validateAssessment(assessmentData, sections)

        if (!validData?.formValid) {
            setAssessmentData({ ...validData?.assessmentData })
            setSections([...validData?.sections])
            setApiError("Cannot save: please add the required fields in red above")
            setTimeout(() => {
                const id = validData?.scrollid
                const divElement = document.getElementById(id)
                divElement?.scrollIntoView({ behavior: "auto" });
            });
            return
        } else {
            validData = Validators.validateAssessmentSummary(summary)
            if (!validData?.formValid) {
                setSummary(prevState => {
                    return[...validData?.summary];
                })
                setApiError("Cannot save: please add the required fields in Summary")

            } else {
                setloading(true)
                try {

                    // Getting assets from all questions
                    let allAssets = [];
                    let assetError = false;
                    sections.forEach(section => {
                        section.questions.forEach(question => {
                            if (question.questiontype.value == 6 && question.assets?.length == 0) {
                                setApiError("Cannot save: please add source image for graphical submission");
                                assetError = true;
                                return;
                            }
                            if (question.assets?.length > 0) {
                                let asset = question.assets?.filter(elem => { return !elem.id; })
                                allAssets = [...allAssets, ...asset]
                            }
                        });
                    });

                    if (assetError) {
                        setloading(false);
                        return;
                    }
                    if (allAssets.length > 0) {
                        // This method will assign "image" key for all the objects which holds the image data in backend.
                        // IMPORTANT: "image" key will be updated to respective assets unders each questions by object reference.
                        await uploadAllQuestionAssets(allAssets);
                    }

                    let sectionData = JSON.parse(JSON.stringify(sections));

                    sectionData?.forEach(section => {
                        section["sectionname"] = section["sectionname"]?.value
                        section["sectionsummary"] = section["sectionsummary"]?.value
                        section.questions?.forEach(question => {
                            question["questionname"] = question["questionname"]?.value
                            question["questiontype"] = question["questiontype"]?.value
                            question["questionscore"] = assessmentData.scoreparameter.value == 1 ? question["questionscore"] == "" ? null : question["questionscore"] : 0
                            delete question.id;
                            delete question.sectionid;
                            delete question.assessmentid;
                            delete question.createddate;
                            delete question.updateddate;

                            question?.assets?.forEach(asset => {
                                if (!asset.id) {
                                    delete asset.url;
                                }
                                delete asset.id;
                                delete asset.questionid;
                                delete asset.file;
                            });

                            question.optionset?.forEach(optionset => {
                                optionset.options?.forEach(option => {
                                    option["optionname"] = option["optionname"]?.value
                                    option["score"] = assessmentData.scoreparameter.value == 1 ? option["score"]?.value : 0
                                    delete option.id;
                                    delete option.questionid;
                                    delete option.createddate;
                                    delete option.updateddate;
                                });
                            });
                        });
                        delete section.id;
                        delete section.assessmentid;
                        delete section.createddate;
                        delete section.updateddate;
                    });

                    let assessments = {}
                    Object.keys(assessmentData).map(data => {
                        assessments[data] = assessmentData[data] != null && typeof assessmentData[data] == "object" ? assessmentData[data]?.value : assessmentData[data]
                    });
                    assessments["sections"] = sectionData;
                    assessments['summary'] = JSON.parse(JSON.stringify(summary));
                    
                    assessments['settings'] = JSON.parse(JSON.stringify(assessmentData.settings));
                    delete assessments.settings.id;

                    assessments['summary']?.map((summaryElem, sindex) => {
                        delete summaryElem.id;
                        delete summaryElem.assessmentid;
                        delete summaryElem.createddate;
                        delete summaryElem.updateddate;
                        // delete summaryElem.sectionid
                        if (!summaryElem.isdefaultsummary) {
                            let checkedQuestions = [];
                            if (summaryElem?.questions?.length > 0) {
                                summaryElem?.questions?.map(question => {
                                    checkedQuestions = [
                                        ...checkedQuestions,
                                        ...question.options?.filter(elem => { return elem.checked })?.map(elem => { return { questionuniqueid: elem.questionuniqueid } })
                                    ];
                                });
                            }
                            summaryElem["questions"] = checkedQuestions;

                        }

                        summaryElem["summaryname"] = summaryElem["summaryname"]?.value
                        summaryElem["basedon"] = summaryElem["basedon"]?.value
                        summaryElem['defaultconfiguration']?.map((config) => {
                            config["operator"] = config["operator"]?.value
                            config["scoremin"] = config["scoremin"]?.value
                            config["description"] = config["description"]?.value
                            config["indicatorname"] = config["indicatorname"]?.value
                            config["scoremax"] = config["scoremax"]?.value
                        })
                        summaryElem['kpi']?.map((kpi) => {
                            delete kpi.id;
                            delete kpi.summaryid;
                            delete kpi.createddate;
                            delete kpi.updateddate;
                            kpi["indicatorname"] = kpi["indicatorname"]?.value
                            kpi['configuration']?.map((kpiconfig) => {
                                kpiconfig["operator"] = kpiconfig["operator"]?.value
                                kpiconfig["scoremin"] = kpiconfig["scoremin"]?.value
                                kpiconfig["scoremax"] = kpiconfig["scoremax"]?.value
                                kpiconfig["displayname"] = kpiconfig["displayname"]?.value
                                kpiconfig["color"] = kpiconfig["color"]?.value
                            })
                        })
                    })
                    postApi(assessmentAdd, { data: assessments }).then(response => {
                        setloading(false)
                        setAlertMessage("Assessment has been saved successfully", "info", () => {
                            props.history.goBack();
                        });
                    }).catch((error) => {
                        setloading(false);
                        setApiError(error?.response?.data?.message || "Error while creating assessment");
                    });
                } catch (error) {
                    setloading(false);
                    console.log(error);
                }
            }
        }
    };

    const uploadAllQuestionAssets = (assets) => {
        return Promise.all(assets?.map(asset => { return uploadLargetAsset(asset); }));
    };

    const dragOver = (e) => {
        e.preventDefault();
    };

    const dragEnter = (e) => {
        e.preventDefault();
    };

    const dragLeave = (e) => {
        e.preventDefault();
    };

    const generateQuestionUsingAI = () => {

        if (constModal?.data?.questions?.length > 0) {
            if (Number(constModal?.data?.selectedQuesIndex) >= 0) {
                let question = constModal?.data?.questions[constModal?.data?.selectedQuesIndex];
                setSections((prevState) => {
                    let questionList = prevState[constModal?.data?.sectionIndex].questions;
                    questionList.push(getDefaultQuestionData(question.questionname, question.hint, parseInt(question.questiontype), question.questionorder, question.questionuniqueid, question?.questionscore, null, false, false, null, null, false, false, false, false, null, false, null, question.optionset,[]))
                    return [...prevState];
                });
            } else {
                setConstModal(prevState => {
                    return {
                        ...prevState,
                        loading: false,
                        data: {
                            ...prevState.data,
                            error: "Please select question"
                        }
                    }
                });
            }
            setConstModal({ show: false, data: {} });
        } else {
            setConstModal(prevState => {
                prevState.loading = true;
                return { ...prevState };
            });
            postApi(aiQuestionGenerate, {
                data: {
                    question_type: constModal?.data?.questiontype,
                    "no_of_questions": 0,
                    text: constModal?.data?.prompt,

                }
            }).then(response => {
                let questionList =  ((Array.isArray(response.data.data) && response.data.data) || []).filter(i => i?.questionname);
                if (questionList.length > 0) {
                    setConstModal(prevState => {
                        return {
                            ...prevState,
                            loading: false,
                            data: {
                                ...prevState.data,
                                questions: questionList,
                                error:""
                            }
                        }
                    });
                }
                else {
                    setConstModal(prevState => {
                        return {
                            ...prevState,
                            loading: false,
                            data: {
                                ...prevState.data,
                                error: typeof (response?.data?.data) == "string" ? response?.data?.data : "Please try again and if issue persist contact Helpdesk"
                            }
                        }
                    });
                }


            }).catch((error) => {
                setConstModal(prevState => {
                    return {
                        ...prevState,
                        loading: false,
                        data: {
                            ...prevState.data,
                            error: error?.response?.data?.message ? error?.response?.data?.message : error?.message
                        }
                    }
                });
                console.log(error);
            });
        }
    };
    const deleteAssessment = () => {
        if (props.location.pathname.includes('edit')) {
            deleteApi(`${assessmentDelete}${props.match.params.assessmentid}`, { data: {} }).then(response => {
                props.history.goBack()

            }).catch((error) => {
                let msg = error?.response?.data?.message ? error?.response?.data?.message : error?.response?.data?.message
                setConstModal(prevState => {
                    prevState.loading = false;
                    prevState.error = msg;
                    return { ...prevState };
                });
            });
        }
        else {
            props.history.goBack()
        }
    }

    const saveImageModal = (data) => {
        setSections(prevState => {
            let question = prevState[data.sectionIndex].questions[data.qIndex];
            question["assets"] = [getDefaultImageData(data.value.name, data.value.type, data.value.size, data.value, URL.createObjectURL(data.value))];
            return [...prevState];
        })
        setConstModal({show: false, data: {}});
        setAttachedImage("");
    }

    const cancelImageModal = () => {
        setConstModal({show: false, data: {}});
        setAttachedImage("");
    }

    return (
        <>
            {assessmentLoading ? <div className="d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100%' }}>
                <img className='assessment-loader' src={`${process.env.PUBLIC_URL}/static/images/loader.svg`} alt="loader-icon" />
            </div> :
            <>
               {/* Floating Buttons */}
                 {isAtTop && (
                <button
                    onClick={scrollToTop}
                    className="text-2l"
                    style={{
                        position: "fixed",
                        bottom: "30px",
                        right: "20px",
                        backgroundColor: "#5c2e91",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "50px",
                        height: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        zIndex: 10,
                        boxShadow: "0px 4px 6px rgba(0,0,0,0.5)"
                    }}
                >
                    ↑
                </button>
             )}
            
                <div ref={scrollContainerRef} className={`assessment-add-container  ${loading ? "disabledbtn" : ""}`} style={{ overflow: "scroll" }}>
                    {alert.message != "" && <Alert variant={alert.variant} key={alert.message} className="sticky-lg-top d-flex w-50" style={{ margin: "0 25% 0 25%" }} dismissible>
                                    {alert.message}
                                </Alert>}
                  
                    <div className='assessment-header-container d-flex clickable align-items-center' onClick={() => { props.history.goBack(); }}>
                        {/* <img src={`${process.env.PUBLIC_URL}/static/images/editing.png`} alt={"editing"} /> */}
                        <img style={{ width: '1.5rem' }} src={`${process.env.PUBLIC_URL}/static/images/back.png`} alt={"back"} />
                        <div className='screen-sub-head' >{title}</div>
                    </div>

                    <div className="assessment-container px-4" id="assessmentData">

                        {/** Assessment Container. Here goes all the fields related to assessment. */}
                        <div className="d-flex flex-column w-100 gap-3 border-style py-4">
                            <div className="d-flex">
                                <div className="w-85 d-flex flex-column gap-3">
                                    {/** Assessment name */}
                                    <div className="w-100 d-flex align-items-start">
                                        <label className="w-20 font-weight-bold">Assessment Name <span className="text-danger">*</span></label>
                                        <div className="w-80">
                                            <TextInput name={'assessmentname'} placeholder={'Assessment Name'} value={assessmentData?.assessmentname?.value}
                                                onChange={(event) => onChangeAssessmentData('assessmentname', event.target.value)} ignoreDefaultErrorSpace
                                                maxlength={150} error={assessmentData?.assessmentname?.error}
                                            />
                                        </div>
                                    </div>

                                    {/** Assessment Description */}
                                    <div className="w-100 d-flex align-items-start">
                                        <label className="w-20 font-weight-bold">Description</label>
                                        <div className="w-80">
                                            <TextInput name={'subtitle'} placeholder={'Subtitle (Optional)'} value={assessmentData?.subtitle?.value}
                                                onChange={(event) => onChangeAssessmentData('subtitle', event.target.value)} ignoreDefaultErrorSpace
                                                maxlength={150} />
                                        </div>
                                    </div>

                                    <div className="w-100 d-flex align-items-start">
                                        <label className="font-weight-bold w-20">Score Parameter <span className="text-danger"></span></label>
                                        <div className='assessment-row w-80'>
                                            <Form className='d-flex run-type-controls gap-3'>
                                                <Form.Check id="scoreparameter-1" type="radio" label="Score/Graded" name="scoreparameter" value={1} checked={assessmentData.scoreparameter.value == 1} onChange={(e) => onChangeAssessmentData(e.target.name, e.target.value)} />
                                                <Form.Check id="scoreparameter-2" type="radio" label="No Score/Non Graded" name="scoreparameter" value={2} checked={assessmentData.scoreparameter.value == 2} onChange={(e) => onChangeAssessmentData(e.target.name, e.target.value)} />
                                            </Form>
                                        </div>
                                    </div>
                                </div>

                                {assessmentData.scoreparameter.value == 1 ? (
                                    <div className="d-flex w-15 align-items-center justify-content-evenly icons">
                                        <button type="button" className="btn btn-white" onClick={() => { openSummaryModal() }}>
                                            <img width="12px" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                            <div>Summary</div>
                                        </button>
                                    </div>
                                ) : ''}
                            </div>

                            {/** Assessment Subject, Complexity and Settings */}
                            <div className="w-100 ">
                                <div className="w-100 d-flex gap-2 subject">
                                    <div className="w-80 d-flex align-items-center justify-content-center inputview">
                                        <label className="font-weight-bold">Programme <span className="text-danger">*</span></label>
                                        <DropdownInput size={"md"} name='programmeid' defaultValue="Programme" value={assessmentData.programmeid?.value} options={programmeListData} onChange={(value) => onChangeAssessmentData('programmeid', value)}
                                            error={assessmentData.programmeid?.error} />
                                    </div>
                                    <div className="w-80 d-flex align-items-center justify-content-center inputview">
                                        <label className="font-weight-bold">Subject <span className="text-danger">*</span></label>
                                        <DropdownInput size={"md"} name='subjectid' defaultValue="Subject" value={assessmentData.subjectid?.value} options={subjectListData} onChange={(value) => { onChangeAssessmentData('subjectid', value) }}
                                            error={assessmentData.subjectid?.error} />
                                    </div>
                                    <div className="w-80 d-flex align-items-center justify-content-center inputview">
                                        <label className="font-weight-bold" >Complexity <span className="text-danger">*</span></label>
                                        <DropdownInput size={"md"} name='complexity' defaultValue="Complexity" value={assessmentData.complexity?.value} options={complexity} onChange={(value) => onChangeAssessmentData('complexity', value)}
                                            error={assessmentData.complexity?.error} />
                                    </div>

                                    <div className="d-flex w-40 align-items-center justify-content-evenly icons assessment-menu">
                                        <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/webeye.png`} onClick={() => {
                                            let sectionList = [...sections]?.map((section) => {
                                                return ({
                                                    ...section,
                                                    questions: section?.questions?.map((qitem) => {
                                                        let opsetindex = qitem.optionset?.findIndex((opset) => opset.isdefaultset)
                                                        // let optionset = qitem.optionset?.filter((opset) => opset.isdefaultset).length > 0 ? qitem.optionset?.filter((opset) => opset.isdefaultset) : qitem.optionset.length > 0 ? qitem.optionset[0] : []
                                                        return ({
                                                            questionname: qitem?.questionname?.value,
                                                            questiontype: qitem?.questiontype?.value,
                                                            options: opsetindex >= 0 ? qitem.optionset[opsetindex]["options"] : qitem.optionset.length > 0 ? qitem.optionset[0]["options"] : []
                                                        })
                                                    })
                                                })
                                            })
                                            let programmeindex = programmeListData?.findIndex(i => i?.id == assessmentData?.programmeid?.value)
                                            let subjectindex = subjectListData?.findIndex(i => i?.id == assessmentData?.subjectid?.value)
                                            setsectionIndex(0)
                                            setquestionIndex(0)
                                            setConstModal({
                                                show: true,
                                                data: {
                                                    name: "Preview",
                                                    assessmentData: { sections: sectionList },
                                                    printview: false,
                                                    programme: programmeListData[programmeindex]?.value,
                                                    subject: subjectListData[subjectindex]?.value,
                                                }
                                            })
                                        }} className={!Validators.onlyValidateAssessment(assessmentData, sections) ? 'disabledbtn' : ''} />
                                        <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/settingb.png`} onClick={() => {
                                            setConstModal({
                                                show: true,
                                                data: {
                                                    name: "Assessment Settings",
                                                    evaluationType: "Score",
                                                    ...assessmentData?.settings
                                                }
                                            })
                                        }} />
                                        {/* <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/clone.png`} /> */}
                                        <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`}
                                            onClick={() => {
                                                // deleteAssessment()
                                                setConstModal({
                                                    show: true,
                                                    data: { name: "delete" }
                                                })
                                            }} />
                                        <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/php.png`}
                                            onClick={() => {
                                                let ques = []
                                                let sectionList = [...sections]?.map((section) => {
                                                    return ({
                                                        ...section,
                                                        questions: section?.questions?.map((qitem) => {
                                                            let opsetindex = qitem.optionset?.findIndex((opset) => opset.isdefaultset)
                                                            // let optionset = qitem.optionset?.filter((opset) => opset.isdefaultset).length > 0 ? qitem.optionset?.filter((opset) => opset.isdefaultset) : qitem.optionset.length > 0 ? qitem.optionset[0] : []
                                                            return ({
                                                                questionname: qitem?.questionname?.value,
                                                                questiontype: qitem?.questiontype?.value,
                                                                options: opsetindex >= 0 ? qitem.optionset[opsetindex]["options"] : qitem.optionset.length > 0 ? qitem.optionset[0]["options"] : []
                                                            })
                                                        })
                                                    })
                                                })
                                                sectionList.map((sd) => { ques = [...ques, ...sd?.questions] })
                                                let programmeindex = programmeListData?.findIndex(i => i?.id == assessmentData?.programmeid?.value)
                                                let subjectindex = subjectListData?.findIndex(i => i?.id == assessmentData?.subjectid?.value)
                                                setsectionIndex(0)
                                                setquestionIndex(0)
                                                setConstModal({
                                                    show: true,
                                                    data: {
                                                        name: "Preview",
                                                        assessmentData: { ...assessmentData, sections: sectionList, questions: ques },
                                                        printview: true,
                                                        programme: programmeListData[programmeindex]?.value,
                                                        subject: subjectListData[subjectindex]?.value,
                                                    }
                                                })

                                            }} className={!Validators.onlyValidateAssessment(assessmentData, sections) ? 'disabledbtn' : ''} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/** Section Container */}
                        <div className="section-container" ref={scrollRef}>

                            {/** Middle Section */}
                            <div className="middle-section">
                                {
                                    sections.length > 0 && sections?.map((section, sectionIndex) => (
                                        <div className="section  py-4" id={`section ${sectionIndex}`}>

                                            {/** Section title and Controls */}
                                            <div className="d-flex ">
                                                <div className="d-flex flex-column w-85 gap-3">
                                                    <div className="d-flex">
                                                        <label className="w-20 font-weight-bold">Section</label>
                                                        <div className="d-flex w-80">
                                                            <div className="w-100 d-flex align-items-center justify-content-center">
                                                                <TextInput name={'sectionname'} placeholder={'Section Title'} value={section?.sectionname?.value}
                                                                    onChange={(event) => onChangeSectionData(sectionIndex, 'sectionname', event)} ignoreDefaultErrorSpace
                                                                    maxlength={30} error={section.sectionname?.error} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/** Section Description */}
                                                    <div className="d-flex align-items-center">
                                                        <label className="w-20 font-weight-bold">Description</label>
                                                        <div className="w-80">
                                                            <TextAreaInput name={'sectionsummary'} placeholder={'Summary (Optional)'} value={section.sectionsummary?.value}
                                                                onChange={(event) => onChangeSectionData(sectionIndex, 'sectionsummary', event)} ignoreDefaultErrorSpace />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="d-flex w-15 align-items-center justify-content-evenly icons">
                                                    <button type="button" className="btn btn-white" onClick={() => {
                                                        let validData = Validators.validateAssessment(assessmentData, sections)
                                                        if (!validData?.formValid) {
                                                            setAssessmentData({ ...validData?.assessmentData })
                                                            setSections([...validData?.sections])
                                                            setTimeout(() => {
                                                                const id = validData?.scrollid
                                                                const divElement = document.getElementById(id)
                                                                divElement?.scrollIntoView({ behavior: "auto" });
                                                            });
                                                            return
                                                        } else {
                                                            addSection(sectionIndex)
                                                        }
                                                    }}>
                                                        <img width="12px" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                                        <div>Section</div>
                                                    </button>
                                                    <button type="button" className="btn btn-white" disabled={sections.length <=1} onClick={() => {
                                                        deleteSection(sectionIndex)
                                                    }}>
                                                        <img  width="20px" className={`${sections.length > 1 ? '' : 'disabled'} me-4`}  src={`${process.env.PUBLIC_URL}/static/images/delete.png`} alt="plusb" />
                                                    </button>
                                                </div>
                                            </div>


                                            {/** Questions under the section */}
                                            <div className="d-flex flex-column my-2">

                                                <label className="font-weight-bold">Questions</label>
                                                <div className="d-flex flex-column gap-4">
                                                    {
                                                        section.questions.length > 0 ?
                                                            section.questions?.map((qitem, qindex) => (
                                                                <>
                                                                <div className="font-weight-bold mt-3">Question - {qindex + 1}</div>

                                                                <div id={`question ${sectionIndex} ${qindex}`} key={"question-" + qindex} className="question-container  position-relative gap-3">

                                                                    {/** Question heading with number */}
                                                                    {/** Question Name Editor */}
                                                                    <div className="text-editor">
                                                                        <div className={`wrapper ${qitem.questionname?.error ? "errorques" : ""}`}>
                                                                        <ReactQuillEditor
                                                                             reference={quillRef}
                                                                             keyItem={qindex}
                                                                             placeholder={"Question Name"}
                                                                             value={qitem.questionname?.value}
                                                                                onChange={(value) => { 
                                                                                    onChangeQuestionData("questionname", value, sectionIndex, qindex)
                                                                                 }} 
                                                                                disabled={false}
                                                                             />
                                                                          
                                                                            {qitem.questionname?.error && <div className="text-danger text-s" style={{ minHeight: '18px', }}>{qitem.questionname?.error ? qitem.questionname?.error : ''}</div>}
                                                                        </div>
                                                                    </div>

                                                                    {/** Question type, rating type, score and controls */}
                                                                    <div className="d-flex gap-2">
                                                                        <div style={{width: '40%'}}>
                                                                        <DropdownInput name='questiontype' defaultValue={'Select a Question Type'} value={qitem.questiontype?.value} options={questionTypes} onChange={(value) => { onChangeQuestionData('questiontype', value, sectionIndex, qindex); }}
                                                                            error={qitem.questiontype?.error}
                                                                        />
                                                                        </div>
                                                                        <div className="d-flex gap-2" style={{width: '40%'}}>
                                                                            {   
                                                                                qitem.questiontype?.value === 7 && 
                                                                                <DropdownInput style={{flex: 1}} name='programmingLanguage' defaultValue={'Programming Language'} value={qitem.programminglanguage} options={programmingLanguages} onChange={(value) => { onChangeQuestionData('programminglanguage', value, sectionIndex, qindex); }}
                                                                                    error={qitem.programminglanguage?.error}/>
                                                                            }

                                                                            {
                                                                                assessmentData.scoreparameter.value == 1 && 
                                                                                <TextInput style={{flex: 1}} name='questionscore' placeholder='Score' value={qitem.questionscore} type='text'
                                                                                onChange={(event) => { onChangeQuestionData(event.target.name, event.target.value, sectionIndex, qindex); }} ignoreDefaultErrorSpace />
                                                                            }
                                                                        </div> 
                                                                        <div className="d-flex gap-3 icons">
                                                                            <MenuItemInput icon={questionMore.icon} items={questionMore.items} data={qitem} onChange={(id, key, value) => { onChangeQuestionData(key, value, sectionIndex, qindex); }} />
                                                                            <MenuItemInput icon={questionClone.icon} items={questionClone.items} data={qitem} onClick={(id) => { duplicateQuestion(sectionIndex, qindex, id === 9 ? true : false); }} />
                                                                            <div className="d-flex align-items-center">
                                                                                <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/attachment.png`} onClick={() => { openMediaPicker("image", sectionIndex, qindex); }} />
                                                                            </div>
                                                                            {/* <div className="d-flex align-items-center">
                                                                                <img width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/settingb.png`} onClick={() => {
                                                                                    setConstModal({
                                                                                        show: true,
                                                                                        data: {
                                                                                            name: "Setting",
                                                                                            qustionIndex: qindex,
                                                                                            sectionIndex: sectionIndex,
                                                                                            question: qitem,
                                                                                            evaluationType: "Score",
                                                                                            section: sectionIndex + 1
                                                                                        }
                                                                                    })
                                                                                }} />
                                                                            </div> */}
                                                                            <div className="d-flex align-items-center">
                                                                                <img width={"20px"} height={"20px"} className={`${section.questions.length > 1 ? '' : 'disabled'}`} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} onClick={section.questions.length > 1 ? () => { deleteQuestion(sectionIndex, qindex,qitem.questionname?.value) } : null} />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/** Question Assets */}
                                                                    {
                                                                        Array.isArray(qitem.assets) && qitem.assets?.map((asset, assetIndex) =>(
                                                                            <div className="assessment-img-section p-3">
                                                                                {
                                                                                    asset.type.startsWith("image") ?
                                                                                        <p className="" >
                                                                                            <img style={{ width: '15rem' }} src={asset.url} alt={asset.name} />
                                                                                        </p> :
                                                                                        asset.type.startsWith("video") ?
                                                                                            <div className="h-50">
                                                                                                <video controls style={{ width: "100%", height: "250px" }}>
                                                                                                    <source src={asset.url} type={asset.type} />
                                                                                                </video>
                                                                                            </div> :
                                                                                            asset.type == "application/pdf" ?
                                                                                                <div className="w-10">
                                                                                                    <a href={asset.url} target="_blank" rel="noopener noreferrer">
                                                                                                        <img className="w-100" src={`${process.env.PUBLIC_URL}/static/images/pdf-icon.png`} />
                                                                                                    </a>
                                                                                                </div> : ''
                                                                                }
                                                                                <img className="mx-2" width={"20px"} height={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/preview.png`} onClick={() =>
                                                                                    setConstModal({ show: true, data: { modalType: "ImagePreview", asset }})}/>

                                                                                <img className="mx-2" width={"15px"} height={"15px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} onClick={() => {
                                                                                    setSections((prevState) => {
                                                                                        const updated = [...prevState];
                                                                                        updated[sectionIndex].questions[qindex].assets.splice(assetIndex, 1);

                                                                                        if (updated[sectionIndex].questions[qindex].questiontype.value == 6 && updated[sectionIndex].questions[qindex].assets?.length === 0) {
                                                                                            setApiError("Cannot save: please add source image for graphical submission");
                                                                                        }
                                                                                        return updated;
                                                                                    });
                                                                                }} />
                                                                            </div>
                                                                        ))
                                                                    }

                                                                    {/** Answer Set Container */}
                                                                    <div className="d-flex gap-5 w-100 ">

                                                                        {/** Answer Set and Answers */}
                                                                        <div className="w-100 ">
                                                                            {
                                                                                qitem.optionset?.map((opset, opsetindex) => (
                                                                                    <div className={`d-flex gap-3 ${opsetindex < qitem?.optionset?.length - 1 ? "border-bottom" : ''} `} key={opsetindex} >

                                                                                        {/** Default Answer Set */}
                                                                                        <div className=" d-flex align-items-center justify-content-center seticon">
                                                                                            <Form.Check size={"lg"} custom type="radio" id={`section-${sectionIndex}-question-${qindex}-optionset-${opsetindex}`} name={`section-${sectionIndex}-question-${qindex}`} label={`Set ${opsetindex + 1}`} value={opset.isdefaultset} defaultChecked={opset.isdefaultset} onChange={(event) => { onChangeAnswerSet(sectionIndex, qindex, opsetindex, event.target.checked); }} />
                                                                                        </div>

                                                                                        {/** Answer Add and Delete */}
                                                                                        <div className="w-100 d-flex gap-3 ">
                                                                                            <div className="d-flex flex-column flex-grow-1 gap-2 w-100 ">
                                                                                                {
                                                                                                    opset.options?.map((option, opindex) => (
                                                                                                        <div className="d-flex align-items-center gap-2 w-100 rowcenter" key={opindex}>
                                                                                                            <div className="d-flex gap-2" style={{ width: '85%' }}>
                                                                                                                <span className="option-section" >
                                                                                                                    <TextInput name={'optionname'} placeholder={'Option ' + (opindex + 1)} value={option.optionname?.value}
                                                                                                                        onChange={(event) => { onChangeOptionData(event.target.name, event.target.value, sectionIndex, qindex, opsetindex, opindex); }} ignoreDefaultErrorSpace
                                                                                                                        error={option.optionname?.error} />
                                                                                                                </span>
                                                                                                                {
                                                                                                                    assessmentData.scoreparameter.value == 1 && 
                                                                                                                    <span className="score-section">
                                                                                                                        <TextInput name={'score'} placeholder={'Score'} value={option.score?.value} type={'text'} onKeyDown={(e) => { if (e.key === "Enter") { addOption(sectionIndex, qindex, opsetindex); } }}
                                                                                                                            onChange={(event) => { onChangeOptionData(event.target.name, event.target.value, sectionIndex, qindex, opsetindex, opindex); }} ignoreDefaultErrorSpace
                                                                                                                            error={option.score?.error} />
                                                                                                                    </span>
                                                                                                                }
                                                                                                            </div>
                                                                                                            <section className="d-flex gap-2" style={{width: '10%'}}>
                                                                                                                <img title="Delete Answer" style={{ width: "1.4rem" }} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/crossb.png`} onClick={() => { optionDelete(sectionIndex, qindex, opsetindex, opindex) }} />
                                                                                                                {opindex === opset.options.length - 1 && !(qitem.questiontype?.value === 2 && opset.options.length >=2) && <img title="Add Answer" style={{ width: "1.4rem" }} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/pluscircle.png`} onClick={() => { addOption(sectionIndex, qindex, opsetindex) }} />}
                                                                                                            </section>
                                                                                                        </div>
                                                                                                    ))
                                                                                                }
                                                                                            </div>
                                                                                        </div>

                                                                                        {/** Delete Answer Set && Add Option */}
                                                                                        <div className="w-10 d-flex align-items-center justify-content-end gap-2 icons">
                                                                                            {/* <img title="Add Answer" style={{ width: "1.4rem" }} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/pluscircle.png`} onClick={() => { addOption(sectionIndex, qindex, opsetindex) }} /> */}
                                                                                            <img title="Delete Answer Set" style={{ width: "1.4rem" }} onClick={() => { deleteSet(sectionIndex, qindex, opsetindex); }} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} />
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>

                                                                        {/** Add Answer Set */}
                                                                        <div className=" d-flex align-items-center justify-content-center flex-column">
                                                                        {!(qitem.questiontype?.value === 4 || qitem.questiontype?.value === 3 || qitem.questiontype?.value === 6 || qitem.questiontype?.value === 7) && 
                                                                        <button title="Add Answer Set" type="button" className="btn btn-white d-flex align-items-center justify-content-center gap-2 icons" onClick={() => { addOptionSet(sectionIndex, qindex) }}>
                                                                            <img width="20px" src={`${process.env.PUBLIC_URL}/static/images/answerset.png`} alt="plusb" />
                                                                            <text className="answer-label">Answer Set</text>
                                                                        </button>}
                                                                        </div>
                                                                    </div>

                                                                    {/* <TextInput name={'hint'} placeholder={'Hint (Optional)'} value={qitem.hint}
                                                            onChange={(event) => { onChangeQuestionData(event.target.name, event.target.value, qindex); }} ignoreDefaultErrorSpace /> */}

                                                                    {/* <button type="button" className="btn btn-white "
                                                                                    onClick={() => {
                                                                                        let ans = qitem.optionset.filter(e => e.isdefaultset)
                                                                                        setMenuModal("")
                                                                                        setConstModal({
                                                                                            show: true,
                                                                                            data: {
                                                                                                name: "link",
                                                                                                qustionIndex: qindex,
                                                                                                sectionIndex: sectionIndex,
                                                                                                question: qitem,
                                                                                                linkSet: [{ index: 1 }],
                                                                                                answerSet: ans.length > 0 ? ans[0]?.options : [],
                                                                                                questions: section.questions
                                                                                            }
                                                                                        })
                                                                                    }}>
                                                                                    <div className="link text-1s">Link or Conditional Settings</div>
                                                                                </button> */}

                                                                </div>
                                                                </>
                                                            )) :
                                                            <div className="px-2">No questions available.</div>
                                                    }
                                                </div>
                                                <div className="d-flex  align-items-center align-self-center my-2 rowcenter  justify-content-center">
                                                    <button type="button" className="btn btn-grey-light mx-2" onClick={() => {
                                                        let validData = Validators.validateAssessment(assessmentData, sections)
                                                        if (!validData?.formValid) {
                                                            setAssessmentData({ ...validData?.assessmentData })
                                                            setSections([...validData?.sections])
                                                            setTimeout(() => {
                                                                const id = validData?.scrollid
                                                                const divElement = document.getElementById(id)
                                                                divElement?.scrollIntoView({ behavior: "auto" });
                                                            });
                                                            return
                                                        } else {
                                                            addSection(sectionIndex)
                                                        }
                                                    }}>
                                                        <div>  <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" /> Section</div>
                                                    </button>

                                                    <button type="button" className="btn btn-grey-light mx-2" onClick={() => { addQuestion(sectionIndex) }}>
                                                        <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                                        Question
                                                    </button>
                                                    <span className="mx-2"> OR</span>
                                                    <button type="button" className="btn btn-grey-light mx-2" onClick={() => {
                                                        setConstModal({
                                                            show: true,
                                                            data: {
                                                                name: "AI",
                                                                sectionIndex: sectionIndex
                                                            }
                                                        })
                                                    }}>
                                                        <img width="15px" className="mx-2" src={`${process.env.PUBLIC_URL}/static/images/ai.png`} alt="plus" />
                                                        AI Generated
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            {/** Bottom Section */}
                            <div className="bottom-section d-flex flex-column ">
                                <div className="text-danger mb-3">{apiError}</div>
                                <div className="d-flex gap-3 rowcenter  justify-content-center">
                                    <button type="button" className="btn btn-outline-primary" onClick={() => {
                                         setConstModal({
                                            show: true,
                                            data: {
                                                name: "Cancel Modal",
                                            }
                                        })
                                        //  props.history.goBack();
                                     }}>Cancel</button>
                                    <button type="button" className="btn btn-primary" onClick={()=>{ saveAssessment() }} disabled={disableSave}>
                                        {props.location.pathname.includes('edit')?"Update":"Save"} {loading && <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/** Settings Modal */}
                    <Modal centered show={constModal.show} size={constModal?.data?.name === 'Summary' ? 'xl' : 'lg'} animation={true}>
                        <Modal.Header className="modal-header">
                            {constModal?.data?.name == "link" &&
                                <div className="d-flex align-items-center">
                                    <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/link.png`} alt="link" />
                                    <div className="modal-head">Link / Conditional Settings</div>
                                </div>}
                            {constModal?.data?.name == "AI" &&
                                <div className="d-flex align-items-center">
                                    <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/ai.png`} alt="ai" />
                                    <div className="modal-head">Create question using AI</div>
                                </div>}
                            {constModal?.data?.name == "delete" &&
                                <div className="d-flex align-items-center">
                                    <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/delete.png`} alt="delete" />
                                    <div className="modal-head">Delete</div>
                                </div>}
                            {/* {constModal?.data?.name == "Setting" &&
                                <div className="d-flex align-items-center">
                                    <img width="15px" className="mx-2" src={`${process.env.PUBLIC_URL}/static/images/settings.png`} alt="settings" />
                                    <div className="modal-head">Question Settings</div>
                                </div>} */}
                            {constModal?.data?.name == "Assessment Settings" &&
                                <div className="d-flex align-items-center">
                                    <img width="20px" className="mx-2" src={`${process.env.PUBLIC_URL}/static/images/settings.png`} alt="settings" />
                                    <div className="modal-head">Assessment Settings</div>
                                </div>}
                            {constModal?.data?.name == "Preview" &&
                                <div className="d-flex align-items-center">
                                    {/* <img width="15px" className="mx-2" src={`${process.env.PUBLIC_URL}/static/images/settings.png`} alt="settings" /> */}
                                    <div className="modal-head">{constModal?.data?.printview ? "" : "Preview"}</div>
                                </div>}
                            {
                                constModal.data.name === 'Summary' &&
                                <div className="d-flex align-items-center font-weight-bold">Summary</div>
                            }
                             {
                                constModal.data.name === 'Cancel Modal' &&
                                <div className="d-flex justify-content-center align-items-center font-weight-bold"> Are you sure want to cancel the assessment?</div>
                            }
                            {
                                constModal.data.name === 'Delete Modal' &&
                                <div className="d-flex justify-content-center align-items-center font-weight-bold"> Are you sure want to delete the {constModal.data.type}?</div>
                            }


                            <div className="d-flex align-items-center flex-column gap-2">
                                <div className="cursor-pointer close-icon" onClick={() => {
                                    setConstModal({
                                        show: false,
                                        data: {}
                                    })
                                }}
                                >X</div>
                                {constModal?.data?.name == "Preview" && constModal?.data?.printview && <div className=" justify-content-end">
                                    <Button onClick={() => {
                                        let printableElements = document.getElementById('assessmentPreview').innerHTML;
                                        let orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
                                        
                                        let oldPage = document.body.innerHTML;
                                        document.body.innerHTML = orderHtml;
                                        window.print();
                                        // 
                                        // window.location.reload();
                                        document.body.innerHTML = oldPage;
                                       
                                    }}>Print</Button>
                                </div>}
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                                {alert.message != "" && <Alert variant={alert.variant} className="sticky-lg-top" dismissible>
                                    {alert.message}
                                </Alert>}
                        {
                                constModal.data.name === 'Cancel Modal' &&
                                    <div>
                                        {/* <div className="d-flex justify-content-center align-items-center font-weight-bold"> Are you sure you want to Cancel ?</div> */}
                                        <div className="d-flex gap-3 rowcenter  justify-content-center mt-3">
                                            <button type="button" className="btn btn-outline-primary" onClick={() => {
                                                setConstModal({
                                                    show: false,
                                                    data: {
                                                        name: "",
                                                    }
                                                })
                                            }}>No</button>
                                            <button type="button" className="btn btn-primary" onClick={() => { props.history.goBack(); }}>Yes</button>
                                        </div>
                                    </div>
                            }
                             {
                                constModal.data.name === 'Delete Modal' &&
                                    <div>
                                        {/* <div className="d-flex justify-content-center align-items-center font-weight-bold"> Are you sure you want to Cancel ?</div> */}
                                        <div className="d-flex gap-3 rowcenter  justify-content-center mt-3">
                                            <button type="button" className="btn btn-outline-primary" onClick={() => {
                                                setConstModal({
                                                    show: false,
                                                    data: {
                                                        name: "",
                                                    }
                                                })
                                            }}>No</button>
                                            <button type="button" className="btn btn-primary" onClick={() => { 
                                                 setConstModal({
                                                    show: false,
                                                    data: {
                                                        name: "",
                                                    }
                                                })
                                                constModal.data.delete()
                                                 }}>Yes</button>
                                        </div>
                                    </div>
                            }
                            {
                                constModal?.data?.name == "AI" &&
                                <div>
                                    {
                                        constModal?.data?.questions?.length > 0 ?
                                            <div>
                                                {
                                                    constModal?.data?.questions?.map((question, qindex) => (
                                                        <div>
                                                            <Form.Check
                                                                type="radio"
                                                                label={question.questionname}
                                                                key={'ai-question-' + qindex}
                                                                id={'ai-question-' + qindex}
                                                                value={qindex}
                                                                checked={constModal?.data?.selectedQuesIndex == qindex ? true : false}
                                                                onChange={(event) => {
                                                                    setConstModal(prevState => {
                                                                        return {
                                                                            ...prevState, data: {
                                                                                ...prevState.data,
                                                                                selectedQuesIndex: qindex
                                                                            }
                                                                        }
                                                                    });
                                                                }} />
                                                            <div className="mx-5">{
                                                                question?.optionset?.map((set, seti) => (
                                                                    <div>
                                                                        <div>Set {seti + 1}</div>
                                                                        <div className="mx-5">{set?.options?.map((option) => (
                                                                            <div className="d-flex gap-5">
                                                                                <div className="w-50">option {option?.optionname}</div>
                                                                                <div className="justify-content-end">score {option?.score}</div>
                                                                            </div>
                                                                        ))}</div>
                                                                    </div>
                                                                ))
                                                            }</div>

                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            :
                                            <div>
                                                <div className=" d-flex align-items-center justify-content-center flex-column">
                                                    <textarea className="text-area" name={'prompt'} label={'Enter Prompt or Paste text'} placeholder={'Enter Prompt or Paste text'} value={constModal?.data?.prompt}
                                                        onChange={(event) => {
                                                            setConstModal(prevState => {
                                                                return {
                                                                    ...prevState, data: {
                                                                        ...prevState.data,
                                                                        [event.target.name]: event.target.value,
                                                                        error: ""
                                                                    }
                                                                }
                                                            })
                                                        }} />
                                                    {/* <div className="ortext">OR</div> */}
                                                    {/* <div className="upload-component" onDragOver={dragOver} onDragEnter={dragEnter} onDragLeave={dragLeave}
                                                onClick={() => { document.getElementById('media').click(); }}
                                                onDrop={(event) => {
                                                    event.preventDefault();
                                                    let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
                                                    if (files?.length > 0) {
                                                        // if(files[0]['type'].includes('video/')){
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    media: URL.createObjectURL(files[0])
                                                                }
                                                            }
                                                        })
                                                        // }
                                                    }
                                                }}>
                                                <div className="drop-text">Upload Media / Drop Media Here </div>
                                                <Button className="btn btn-primary" onClick={() => { document.getElementById('media').click(); }}>Upload Media</Button>
                                                <Form.Control id="media" name="image" type="file" onChange={(event) => {
                                                    event.preventDefault();
                                                    if (event.target.files?.length > 0) {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState,
                                                                data: {
                                                                    ...prevState.data,
                                                                    media: URL.createObjectURL(event.target.files[0])
                                                                }
                                                            }
                                                        })
                                                    }

                                                }} accept={FILE + IMAGE_TYPES} hidden />
                                            </div> */}
                                                </div>
                                                <p className="my-2 font-weight-bold">Choose Question Type to generate</p>
                                                <div className="d-flex align-items-center gap-4 ">
                                                    {
                                                        aiQuestionTypes.map((item) => (
                                                            <Form.Check custom type="radio" key={"create-question-ai-" + item.id} id={"create-question-ai-" + item.id} label={item.value} value={item.id} checked={constModal?.data?.questiontype == item?.id ? true : false}
                                                                onChange={(event) => {
                                                                    setConstModal(prevState => {
                                                                        return {
                                                                            ...prevState,
                                                                            data: {
                                                                                ...prevState.data,
                                                                                questiontype: event.target.value,
                                                                                error: ""
                                                                            }
                                                                        }
                                                                    });
                                                                }} />
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                    }
                                    <div className="d-flex justify-content-center ">
                                        {constModal?.data?.error && <div className="text-danger ">{constModal?.data?.error}</div>}
                                    </div>
                                    <div className="d-flex my-3  align-items-center justify-content-center ">
                                        <Button className="btn btn-primary d-flex" 
                                        disabled={!(constModal?.data?.questiontype  && constModal?.data?.prompt )}
                                         onClick={() => { generateQuestionUsingAI(); }}>
                                            Generate {constModal?.loading && <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" />}
                                        </Button>
                                    </div>
                                </div>
                            }
                            {constModal?.data?.name == "delete" &&
                                <div>
                                    {constModal?.error ? <div className="text-danger d-flex align-items-center flex-column gap-3">{constModal?.error}</div> : <div className="d-flex align-items-center flex-column gap-3">
                                        <div>Are you sure you want to delete this Assessment?</div>
                                        <div className="d-flex gap-3 rowcenter">
                                            <button type="button" className="btn btn-outline-primary" onClick={() => {
                                                setConstModal({
                                                    show: false,
                                                    data: {}
                                                })
                                            }}>No</button>
                                            <button type="button" className="btn btn-primary" onClick={() => {
                                                setConstModal(prevState => {
                                                    prevState.loading = true;
                                                    return { ...prevState };
                                                });
                                                deleteAssessment()
                                            }}>Yes {constModal?.loading && <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" />}</button>
                                        </div>
                                    </div>}
                                </div>
                            } {constModal?.data?.name == "link" &&
                                <div>
                                    {constModal?.data?.linkSet?.map((item, index) => (
                                        <div className="d-flex my-3 w-100">
                                            <div className="w-90 py-2">
                                                <div className="d-flex align-items-center gap-5 my-3 ">
                                                    <DropdownInput size={"lg"} name='whentolink' defaultValue={'Select a when to link'} value={item?.whentolink}
                                                        options={linkType}
                                                        onChange={(value) => {
                                                            setConstModal(prevState => {
                                                                let linkset = prevState?.data?.linkSet
                                                                linkset[index] = {
                                                                    ...item,
                                                                    whentolink: value
                                                                }
                                                                return { ...prevState };

                                                            });
                                                        }} />
                                                    <div className="dropdownview flex-row">
                                                        <Dropdown onSelect={(eventKey, event) => {
                                                            setConstModal(prevState => {
                                                                let linkset = prevState?.data?.linkSet
                                                                linkset[index] = {
                                                                    ...item,
                                                                    answer: event.target.innerText
                                                                }
                                                                return { ...prevState };

                                                            });
                                                        }}>
                                                            <Dropdown.Toggle size="sm" variant="default" id="dropdown-basic">
                                                                {item?.answer ? item?.answer : "Select Answer"}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {
                                                                    constModal?.data?.answerSet?.map((elem, index) => (
                                                                        <Dropdown.Item key={elem?.optionname} onClick={() => { }}>{elem?.optionname}</Dropdown.Item>
                                                                    ))
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>

                                                </div>
                                                <div className="d-flex align-items-center gap-5 my-3">
                                                    <DropdownInput name='questionlinktyp' defaultValue={'Select a when to link'} value={item?.questionlinktyp}
                                                        options={questionlinkType}
                                                        onChange={(value) => {
                                                            setConstModal(prevState => {
                                                                let linkset = prevState?.data?.linkSet
                                                                linkset[index] = {
                                                                    ...item,
                                                                    questionlinktyp: value
                                                                }
                                                                return { ...prevState };

                                                            });
                                                        }} />
                                                    <div className="dropdownview flex-row">
                                                        <Dropdown onSelect={(eventKey, event) => {
                                                            setConstModal(prevState => {
                                                                let linkset = prevState?.data?.linkSet
                                                                linkset[index] = {
                                                                    ...item,
                                                                    question: event.target.innerText
                                                                }
                                                                return { ...prevState };

                                                            });
                                                        }}>
                                                            <Dropdown.Toggle size="sm" variant="default" id="dropdown-basic">
                                                                {item?.question ? item?.question : "Select Question"}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {
                                                                    constModal?.data?.questions?.filter(e => e.questionname?.value != constModal?.data?.question?.questionname?.value)?.map((elem, index) => (
                                                                        <Dropdown.Item key={elem?.questionname?.value} onClick={() => { }}>{elem?.questionname?.value}</Dropdown.Item>
                                                                    ))
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex my-3 mx-2 flex-column  align-items-center">

                                                <img className=" m-1 " height={"20px"} width={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/clone.png`} onClick={() => {
                                                    setConstModal(prevState => {
                                                        let linkset = prevState?.data?.linkSet
                                                        linkset.push(item)
                                                        return { ...prevState };

                                                    });
                                                }} />
                                                <img className=" m-1 " height={"20px"} width={"20px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} onClick={() => {
                                                    setConstModal(prevState => {
                                                        let linkset = prevState?.data?.linkSet
                                                        linkset.splice(index, 1)
                                                        return { ...prevState };

                                                    });
                                                }}
                                                />
                                                <img className=" m-1 " height={"20px"} width={"20px"} src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plus" onClick={() => {
                                                    setConstModal(prevState => {
                                                        let linkset = prevState?.data?.linkSet
                                                        linkset.splice(index + 1, 0, { index: linkset.length + 1 })
                                                        return { ...prevState };

                                                    });
                                                }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            }
                            {constModal?.data?.name == "Setting" &&
                                <div className="gap-5">
                                    <div className="d-flex  gap-3 align-items-center">
                                        <div>Section Name:  </div>
                                        <DropdownInput name='section Name' defaultValue={'Select a section'} value={constModal?.data?.section} options={[...sections.map((d, i) => { return ({ value: d?.sectionname?.value, id: i + 1 }) })]}
                                            onChange={(value) => {
                                                value = value - 1
                                                setSections((prevState) => {
                                                    prevState[value].questions.push({ ...prevState[constModal?.data?.sectionIndex].questions[constModal?.data?.qustionIndex], questionorder: prevState[value].questions.length })
                                                    prevState[constModal?.data?.sectionIndex].questions.splice(constModal?.data?.qustionIndex, 1)
                                                    return [...prevState];
                                                });
                                                setConstModal({
                                                    show: false,
                                                    data: {}
                                                });

                                            }} />
                                    </div>
                                    <div className="d-flex  gap-3 align-items-center mt-4">
                                        <div>Proxy Validator:  </div>
                                        <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Yes" value="proxyValidator" checked={constModal?.data?.proxyValidator ? true : false}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            proxyValidator: true
                                                        }
                                                    }
                                                });
                                            }} />

                                        <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="No" value="proxyValidator" checked={!constModal?.data?.proxyValidator ? true : false}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            proxyValidator: false
                                                        }
                                                    }
                                                });
                                            }} />

                                    </div>
                                    <text className="mt-2 text-s" >Source Type : Media/ API/ file (checkbox,only one can be selected)</text>
                                    <div className="d-flex align-items-center gap-5 my-3">
                                        {/* <div className="d-flex  gap-3 w-30 align-items-center">
                                    <div>Time Limit: </div>
                                    <TextInput
                                        name={'mins'} placeholder={'mins'} value={constModal?.data?.mins}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        mins: event.target.value
                                                    }
                                                }
                                            });
                                        }} ignoreDefaultErrorSpace />
                                    <TextInput
                                        name={'sec'} placeholder={'sec'} value={constModal?.data?.sec}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        sec: event.target.value
                                                    }
                                                }
                                            });
                                        }} ignoreDefaultErrorSpace />
                                </div> */}
                                        <div className="d-flex  gap-3 align-items-center">
                                            <div>Evaluation Type:  </div>
                                            <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Score" value="Score" checked={constModal?.data?.evaluationType == "Score" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                evaluationType: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} />
                                            {/* <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Interpretation" value="Interpretation" checked={constModal?.data?.evaluationType == "Interpretation" ? true : false}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        evaluationType: event.target.value
                                                    }
                                                }
                                            });
                                        }} />
                                    <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="TBD" value="TBD" checked={constModal?.data?.evaluationType == "TBD" ? true : false}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        evaluationType: event.target.value
                                                    }
                                                }
                                            });
                                        }} /> */}
                                        </div>
                                       
                                    </div>
                                    <div className="d-flex align-items-center gap-5 my-3">

                                        {/* <div className="d-flex  gap-3 align-items-center">
                                    <div>Shuffle Choices </div>
                                    <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Yes" value="Yes" checked={constModal?.data?.shuffleChoices == "Yes" ? true : false}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        shuffleChoices: event.target.value
                                                    }
                                                }
                                            });
                                        }} />
                                    <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="No" value="No" checked={constModal?.data?.shuffleChoices == "No" ? true : false}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        shuffleChoices: event.target.value
                                                    }
                                                }
                                            });
                                        }} />
                                </div> */}
                                        {/* <div className="d-flex  gap-3 align-items-center">
                                    <div>Penality/Negative Marking</div>
                                    <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Yes" value="Yes" checked={constModal?.data?.negativemark == "Yes" ? true : false}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        negativemark: event.target.value
                                                    }
                                                }
                                            });
                                        }} />
                                    <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="No" value="No" checked={constModal?.data?.negativemark == "No" ? true : false}
                                        onChange={(event) => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState, data: {
                                                        ...prevState.data,
                                                        negativemark: event.target.value
                                                    }
                                                }
                                            });
                                        }} />
                                </div> */}
                                        {constModal?.data?.negativemark == "Yes" && <div className="w-10">
                                            <TextInput
                                                name={'score'} placeholder={'score'} value={constModal?.data?.score}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                score: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} ignoreDefaultErrorSpace />
                                        </div>}
                                    </div>
                                </div>}

                            {constModal?.data?.name == "Preview" &&
                                <div id={"assessmentPreview"} className={"py-2"}>
                                    <div className="my-2">
                                        <div className="assess-title">{assessmentData.assessmentname?.value}</div>
                                        <div className="assess-description">{assessmentData.subtitle?.value}</div>
                                    </div>
                                    <div className="d-flex  justify-content-end m-3 gap-5">
                                        <div className="d-flex gap-2">
                                            <div className="font-weight-bold">Subject:/Topic</div>
                                            <div>{constModal?.data?.subject}</div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <div className="font-weight-bold">Complexity:</div>
                                            <div>{assessmentData.complexity?.value}</div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <div className="font-weight-bold">Programmename:</div>
                                            <div>{constModal?.data?.programme}</div>
                                        </div>
                                    </div>
                                    <RenderQuestionView
                                        assessmentData={constModal?.data?.assessmentData}
                                        sectionIndex={sectionIndex}
                                        questionIndex={questionIndex}
                                        onAction={(key) => {
                                            if (key == "Previous") {
                                                if (questionIndex > 0) {
                                                    setquestionIndex(questionIndex - 1)
                                                } else {
                                                    if (sectionIndex > 0) {
                                                        setquestionIndex(sections?.[sectionIndex - 1]?.questions.length - 1)
                                                        setsectionIndex(sectionIndex - 1)
                                                    }
                                                }
                                            } else {
                                                if (sections?.[sectionIndex]?.questions.length - 1 > questionIndex) {
                                                    setquestionIndex(questionIndex + 1)
                                                } else {
                                                    if (sections?.length - 1 > sectionIndex) {
                                                        setsectionIndex(sectionIndex + 1)
                                                        setquestionIndex(0)
                                                    } else {
                                                        setConstModal({
                                                            show: false,
                                                            data: {}
                                                        })
                                                    }
                                                }
                                            }
                                        }}
                                        printview={constModal?.data?.printview} />
                                    {/* {sections.length > 0 && sections.map((section, sectionIndex) => (
                                    <div>
                                        {section.questions.length > 0 &&
                                            section.questions.map((question, qindex) => (
                                                <div>
                                                </div>
                                            ))}
                                    </div>
                                ))
                            } */}
                                </div>
                            }
                            {constModal?.data?.name == "Assessment Settings" &&
                                <div id={"assessmentsettings"} className={"py-2"}>
                                    <Tabs
                                        defaultActiveKey="general"
                                        id="uncontrolled-tab-example"
                                        className="mb-3"
                                    >
                                        <Tab eventKey="general" title="General">
                                            {/* <div className="d-flex gap-2 align-items-center justify-content-between">
                                        <div className="d-flex gap-2 align-items-center w-40">
                                            <div className="d-flex gap-2 align-items-center">
                                                <label> Start Date:</label>
                                                <TextInput
                                                    name={'mins'} placeholder={'dd/mm/yyyy'} value={constModal?.data?.startdate}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    startdate: event.target.value
                                                                }
                                                            }
                                                        });
                                                    }} ignoreDefaultErrorSpace />
                                            </div>
                                            <div className="d-flex gap-2 align-items-center">
                                                <label> Time:</label>
                                                <TextInput
                                                    name={'time'} placeholder={'hh:mm'} value={constModal?.data?.time}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    stime: event.target.value
                                                                }
                                                            }
                                                        });
                                                    }} ignoreDefaultErrorSpace />
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2 align-items-center w-40">
                                            <div className="d-flex gap-2 align-items-center">
                                                <label> End Date:</label>
                                                <TextInput
                                                    name={'mins'} placeholder={'dd/mm/yyyy'} value={constModal?.data?.enddate}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    enddate: event.target.value
                                                                }
                                                            }
                                                        });
                                                    }} ignoreDefaultErrorSpace />
                                            </div>
                                            <div className="d-flex gap-2 align-items-center">
                                                <label> Time:</label>
                                                <TextInput
                                                    name={'time'} placeholder={'hh:mm'} value={constModal?.data?.time}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    etime: event.target.value
                                                                }
                                                            }
                                                        });
                                                    }} ignoreDefaultErrorSpace />
                                            </div>
                                        </div>
                                    </div> */}
                                            <div className="d-flex gap-2 align-items-center  justify-content-between">
                                                <div className="d-flex gap-2 align-items-center my-3 w-50">
                                                    <div className="d-flex gap-2 align-items-center">
                                                        <label>Assessment Image:</label>
                                                        <div className="d-flex align-items-start">
                                                        <img style={{width: '4rem'}} className="mx-2 h-10 align-self-center" role={"button"}
                                                            src={constModal?.data?.imageurl?.url || constModal?.data?.url || constModal?.data?.imageurl ||`${process.env.PUBLIC_URL}/static/images/image.png`}
                                                            onClick={() => {
                                                                let input = document.createElement('input');
                                                                input.type = 'file';
                                                                input.onchange = async (event) => {
                                                                    if (event.target.files?.length > 0) {
                                                                        let value = event.target.files[0]
                                                                        setConstModal(prevState => {
                                                                            return {
                                                                                ...prevState,
                                                                                data: {
                                                                                    ...prevState.data,
                                                                                    imageurl: getDefaultImageData(value.name, value.type, value.size, value, URL.createObjectURL(value))
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                }

                                                                input.click();
                                                            }} />
                                                           {(constModal?.data?.imageurl?.url || constModal?.data?.url || constModal?.data?.imageurl) && <img className="mx-2" width={"15px"} height={"15px"} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} onClick={() => {
                                                                 setConstModal(prevState => {
                                                                    return {
                                                                        ...prevState,
                                                                        data: {
                                                                            ...prevState.data,
                                                                            imageurl: ""
                                                                        }
                                                                    }
                                                                })
                                                            }} />}
                                                            </div>
                                                    </div>
                                                    {/* <div className="d-flex  gap-3 w-60 align-items-center">
                                                <div>Time Limit: </div>
                                                <TextInput
                                                    name={'mins'} placeholder={'hrs'} value={constModal?.data?.mins}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    mins: event.target.value
                                                                }
                                                            }
                                                        });
                                                    }} ignoreDefaultErrorSpace />
                                                <TextInput
                                                    name={'sec'} placeholder={'mins'} value={constModal?.data?.sec}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    sec: event.target.value
                                                                }
                                                            }
                                                        });
                                                    }} ignoreDefaultErrorSpace />
                                            </div> */}

                                                </div>
                                                <div className="d-flex  gap-3 align-items-center w-50">
                                                    <label>Evaluation Type:  </label>
                                                    <Form.Check custom type="radio" label="Score" value="Score" checked={constModal?.data?.evaluationType == "Score" ? true : false}
                                                        onChange={(event) => {
                                                            setConstModal(prevState => {
                                                                return {
                                                                    ...prevState, data: {
                                                                        ...prevState.data,
                                                                        evaluationType: event.target.value
                                                                    }
                                                                }
                                                            });
                                                        }} />
                                                    {/* <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Interpretation" value="Interpretation" checked={constModal?.data?.evaluationType == "Interpretation" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                evaluationType: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} />
                                            <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="TBD" value="TBD" checked={constModal?.data?.evaluationType == "TBD" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                evaluationType: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} /> */}
                                                </div>

                                            </div>
                                            <div className="  gap-3 my-3 ">
                                                <label>Assessment Instructions:</label>
                                                <div className="w-100 ">
                                                <ReactQuill theme="snow"
                                                        modules={{
                                                            toolbar: [
                                                                // [{ 'font': [] }, { 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                                [{ 'color': [] }, { 'background': [] }],
                                                                ['bold', 'italic', 'underline'],
                                                                ['strike', 'blockquote', 'code-block'],
                                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }]
                                                                // { 'indent': '-1' }, { 'indent': '+1' }],
                                                                // ['clean'],
                                                            ],
                                                            clipboard: {
                                                                // toggle to add extra line breaks when pasting HTML:
                                                                matchVisual: false,
                                                            }
                                                        }}
                                                        placeholder={""}
                                                        value={constModal?.data?.instruction}
                                                        onChange={(value) => {
                                                            setConstModal(prevState => {
                                                                return {
                                                                    ...prevState, data: {
                                                                        ...prevState.data,
                                                                        instruction: value
                                                                    }
                                                                }
                                                            })
                                                        }}
                                                    />
                                                    {/* <textarea className=" w-100" name={'instruction'} label={'Type or Upload Instructions.'} placeholder={'Type or Upload Instructions.'} value={constModal?.data?.instruction}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                [event.target.name]: event.target.value
                                                            }
                                                        }
                                                    })
                                                }} /> */}
                                                    {/* <img className="w-5 mx-2 h-5 align-self-center" role={"button"} src={`${process.env.PUBLIC_URL}/static/images/attachment.png`} onClick={() => {
                                               let input = document.createElement('input');
                                               input.type = 'file';
                                               input.onchange = event => {
                                                   if (event.target.files?.length > 0) {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                instruction: event.target.files[0]
                                                            }
                                                        }
                                                    })
                                                   }
                                               }
                                       
                                               input.click();

                                            }} /> */}
                                                </div>
                                            </div>
                                            <div className="d-flex gap-2 justify-content-between">
                                                {/* <div className="w-50">
                                            <div className="d-flex gap-2 justify-content-between">

                                                <Form.Check custom className="d-flex gap-1 align-items-center" type="checkbox" label="Randomize Questions" checked={constModal?.data?.randomizeQuestions}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    randomizeQuestions: constModal?.data?.randomizeQuestions ? !constModal?.data?.randomizeQuestions : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                                <Form.Check custom className="d-flex gap-1 w-50 align-items-center" type="checkbox" label="Randomize answer set" checked={constModal?.data?.randomizeAnswerSet}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    randomizeAnswerSet: constModal?.data?.randomizeAnswerSet ? !constModal?.data?.randomizeAnswerSet : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                            </div>

                                            <div className="d-flex gap-2 justify-content-between">

                                                <Form.Check custom className="d-flex gap-1 align-items-center" type="checkbox" label="Shuffle choices" checked={constModal?.data?.shuffleChoices}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    shuffleChoices: constModal?.data?.shuffleChoices ? !constModal?.data?.shuffleChoices : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                                <Form.Check custom className="d-flex  w-50 gap-1 align-items-center" type="checkbox" label="Allow multiple answers" checked={constModal?.data?.multipleAns}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    multipleAns: constModal?.data?.multipleAns ? !constModal?.data?.multipleAns : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="w-50">
                                            <div className="d-flex gap-2 justify-content-between">
                                                <Form.Check custom className="d-flex gap-1 align-items-center" type="checkbox" label="Allow response edit" checked={constModal?.data?.allowedit}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    allowedit: constModal?.data?.allowedit ? !constModal?.data?.allowedit : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                            </div>
                                        </div> */}
                                                {/* <div className="w-50">
                                            <div className="d-flex gap-2 justify-content-between">
                                                <Form.Check custom className="d-flex gap-1 align-items-center" type="checkbox" label="Show Progress Bar" checked={constModal?.data?.showProgressBar}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    showProgressBar: constModal?.data?.showProgressBar ? !constModal?.data?.showProgressBar : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                                <Form.Check custom className="d-flex gap-1 w-50 align-items-center" type="checkbox" label="End test on time out" checked={constModal?.data?.timeout}
                                                    onChange={(event) => {
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    timeout: constModal?.data?.timeout ? !constModal?.data?.timeout : true
                                                                }
                                                            }
                                                        });
                                                    }} />
                                            </div>

                                        </div> */}
                                            </div>

                                            {/* <div className="d-flex gap-5 ">

                                        <Form.Check custom className="d-flex gap-1 align-items-center" type="checkbox" label="Allow response edit" checked={constModal?.data?.allowedit}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            allowedit: constModal?.data?.allowedit ? !constModal?.data?.allowedit : true
                                                        }
                                                    }
                                                });
                                            }} />
                                        <Form.Check custom className="d-flex gap-1   align-items-center" type="checkbox" label="Allow reattempts" checked={constModal?.data?.allowattempts}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            allowattempts: constModal?.data?.allowattempts ? !constModal?.data?.allowattempts : true
                                                        }
                                                    }
                                                });
                                            }} />
                                        {constModal?.data?.allowattempts && <div className="d-flex gap-2">
                                            <label>No of Attempts</label>
                                            <TextInput
                                                name={'count'} placeholder={'Count'} value={constModal?.data?.count}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                count: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} ignoreDefaultErrorSpace />
                                        </div>}
                                    </div> */}
                                            {/* <div className="d-flex  gap-3 my-3 ">
                                        <div className="d-flex  gap-3 align-items-center">
                                            <div>Randomize Questions: </div>
                                            <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Yes" value="Yes" checked={constModal?.data?.randomizeQuestions == "Yes" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                randomizeQuestions: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} />
                                            <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="No" value="No" checked={constModal?.data?.randomizeQuestions == "No" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                randomizeQuestions: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} />
                                        </div>
                                        <div className="d-flex  gap-3 align-items-center">
                                            <div>Shuffle Choices </div>
                                            <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Yes" value="Yes" checked={constModal?.data?.shuffleChoices == "Yes" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                shuffleChoices: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} />
                                            <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="No" value="No" checked={constModal?.data?.shuffleChoices == "No" ? true : false}
                                                onChange={(event) => {
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                shuffleChoices: event.target.value
                                                            }
                                                        }
                                                    });
                                                }} />
                                        </div>

                                    </div>

                                    <div className="d-flex  gap-3 align-items-center">
                                        <div>Allow Response/Answer Edit </div>
                                        <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="Yes" value="Yes" checked={constModal?.data?.answerEdit == "Yes" ? true : false}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            answerEdit: event.target.value
                                                        }
                                                    }
                                                });
                                            }} />
                                        <Form.Check custom className="d-flex gap-1 align-items-center" type="radio" label="No" value="No" checked={constModal?.data?.answerEdit == "No" ? true : false}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            answerEdit: event.target.value
                                                        }
                                                    }
                                                });
                                            }} />

                                    </div> */}

                                        </Tab>
                                        {/* <Tab eventKey="proctoring" title="Proctoring">
                                    Tab content for Proctoring
                                </Tab> */}
                                {/* <Tab eventKey="proxyValidator" title="Proxy Validator">
                                    Tab content for Contact
                                </Tab> */}
                                    </Tabs>
                                    <div className="d-flex align-items-center justify-content-center flex-row mt-4">
                                        <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => {
                                            setConstModal({
                                                show: false,
                                                data: {}
                                            })
                                        }}>Cancel</Button>
                                        <Button className="btn btn-primary mx-2" style={{ width: '120px' }} onClick={async () => {
                                            let assessmentImage = constModal?.data?.imageurl;
                                            if ( assessmentImage != null && typeof assessmentImage === 'object' && !assessmentImage.image ) {
                                                const asset = { name: assessmentImage.name, size: assessmentImage.size, file: assessmentImage.file };
                                                let response = await uploadLargetAsset(asset); 
                                                if ( response.status ) {
                                                    assessmentImage.image = asset.image;
                                                }
                                            }

                                            setAssessmentData(prevState => {
                                                prevState.settings.evaluationtype = 1;
                                                prevState.settings.instruction = constModal?.data?.instruction;
                                                prevState.settings.imageurl = assessmentImage;
                                                return {...prevState};
                                            });

                                            setConstModal({
                                                show: false,
                                                data: {}
                                            })
                                        }}>Save</Button>
                                    </div>
                                </div>}
                            {
                                constModal.data.name === 'Summary' &&
                                <div className="d-flex flex-column">
                                    <Tabs id="summary-tab" defaultActiveKey={-1} onSelect={() => { }}>
                                        <Tab eventKey={-1} title="Overall Summary">
                                            <div className="d-flex justify-content-end py-2">
                                                <button type="button" className="btn btn-white" onClick={() => {
                                                    let validData = Validators.validateAssessmentSummary(constModal.data.summaryData)
                                                    if (!validData?.formValid) {
                                                        setConstModal(prevState => {
                                                            prevState.data.summaryData = validData?.summary;
                                                            return { ...prevState };
                                                        })


                                                    } else {
                                                        setConstModal(prevState => {
                                                            prevState.data.summaryData.push(getDefaultSummaryData('', scoringCredit[0].id, true, false));
                                                            return { ...prevState };
                                                        })
                                                    }
                                                }}>
                                                    <img width="12px" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                                    <div>Summary</div>
                                                </button>
                                            </div>
                                            {
                                                constModal.data.summaryData.map((summary, index) =>
                                                    <AssessmentSummaryHOC data={summary} onChange={(data) => {
                                                        setConstModal(prevState => {
                                                            prevState.data.summaryData[index] = data;
                                                            return { ...prevState };
                                                        })
                                                    }}
                                                        summaryList={constModal.data.summaryData}
                                                        summaryIndex={index}
                                                    />
                                                )
                                            }
                                        </Tab>
                                    </Tabs>
                                    <div className="d-flex align-items-center justify-content-center flex-row mt-4">
                                        <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => {
                                            setConstModal({
                                                show: false,
                                                data: {}
                                            })
                                        }}>Cancel</Button>
                                        <Button className="btn btn-primary mx-2" style={{ width: '120px' }} onClick={() => {
                                            let validData = Validators.validateAssessmentSummary(constModal.data.summaryData)
                                            if (validData?.formValid) {
                                                setAlertMessage("Summary has been saved successfully", "info", () => {
                                                    setSummary(constModal.data.summaryData);
                                                    setConstModal({
                                                        show: false,
                                                        data: {}
                                                    })
                                                })
                                            } else {
                                                setConstModal(prevState => {
                                                    prevState.data.summaryData = validData?.summary;
                                                    return { ...prevState };
                                                })
                                            }
                                        }}>Save</Button>
                                    </div>
                                </div>
                            }

                            {
                                constModal?.data.modalType === 'Graphical' && 
                                <div>
                                    <div className="d-flex flex-column">
                                        <span>Source Image</span>
                                        <small className="mt-2 fw-bold">* Please upload only original images, mirror images are not accepted.</small>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center">
                                        <label htmlFor="img-upload" className="d-flex align-items-center justify-content-center p-3 mt-3 clickable"
                                            style={{ border: "2px dashed grey", cursor: "pointer", width: "50%", textAlign: "center", borderRadius: "5px" }} onClick={() => { openMediaPicker("graphicalImage", constModal?.data.sectionIndex, constModal.data.qIndex); }}>
                                            <img src={`${process.env.PUBLIC_URL}/static/images/attachment.png`} alt="default" height="20" width="25" />
                                            <div style={{ color: "blue" }}>Browse files</div>
                                        </label>
                                        <input type="file" accept="application/pdf" id="pdf-upload" style={{ display: "none" }} onChange={() => { openMediaPicker("graphicalImage", constModal.data.sectionIndex, constModal.data.qIndex); }} />
                                    </div>
                                
                                    {attachedImage && (
                                        <div className="mt-3 d-flex flex-column font-weight-bold">
                                            <div>
                                                <span>Preview</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <img src={attachedImage} alt="Preview" style={{ maxWidth: '50%', maxHeight: 250 }} />
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="d-flex align-items-center justify-content-center mt-3 gap-3">
                                        <Button onClick={() => { cancelImageModal() }}>Cancel</Button>
                                        <Button disabled={!attachedImage} onClick={() => { saveImageModal(constModal.data) }}>Save</Button>
                                    </div>
                                </div>
                            }

                            {constModal.show && constModal.data.modalType === "ImagePreview" && (
                                <div className="d-flex justify-content-center clickable">
                                    <img src={constModal.data.asset.url} alt={constModal.data.asset.name} style={{ maxWidth: "100%", maxHeight: "80vh" }} />
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>

                </div>
                </>}
        </>
    )
}

const AssessmentSummaryHOC = ({ data, onChange, summaryList, summaryIndex }) => {
    const [summaryData, setSummaryData] = useState(data ? data : {});

    useEffect(() => {
        onChange && onChange(summaryData);
    }, [summaryData]);

    const onChangeSummaryData = (name, value, kpiIndex = null, configurationIndex = null) => {
        if (value.length === 1 && typeof value === "string" && value.startsWith(" ")) {
            return; // Block input if the first character is a space
        }
        if(name == 'scoremin' || name == 'scoremax') {
            value = value.replace(/[^\d.]/g, '')
        }
        setSummaryData(prevState => {
            if (name === 'indicatorname') {
                if (prevState.kpi[kpiIndex][name] != null && typeof prevState.kpi[kpiIndex][name] === "object") {
                    prevState.kpi[kpiIndex][name] = Validators.validateFormControl(prevState.kpi[kpiIndex][name], value)
                } else {
                    prevState.kpi[kpiIndex][name] = value;
                }
            } else if (name === 'operator' || name === 'scoremin' || name === 'scoremax' || name === 'displayname' || name === 'color') {
                if (prevState.kpi[kpiIndex].configuration[configurationIndex][name] != null && typeof prevState.kpi[kpiIndex].configuration[configurationIndex][name] === "object") {
                    prevState.kpi[kpiIndex].configuration[configurationIndex][name] = Validators.validateFormControl(prevState.kpi[kpiIndex].configuration[configurationIndex][name], value)
                } else {
                    prevState.kpi[kpiIndex].configuration[configurationIndex][name] = value;
                }
            } else {
                if (prevState[name] != null && typeof prevState[name] === "object" && name != "questions") {
                    prevState[name] = Validators.validateFormControl(prevState[name], value)
                } else {
                    prevState[name] = value
                }
            }
            return { ...prevState };
        });
    };

    const onChangeDefaultSummaryConfigurationData = (name, value, configurationIndex = null) => {
        if (value.length === 1 && typeof value === "string" && value.startsWith(" ")) {
            return; 
        }
        if(name === 'scoremin' ||name === 'scoremax'  ){
            value = value.replace(/[^\d.]/g, '')
        }
        setSummaryData(prevState => {
            if (prevState.defaultconfiguration[configurationIndex][name] != null && typeof prevState.defaultconfiguration[configurationIndex][name] === "object") {
                prevState.defaultconfiguration[configurationIndex][name] = Validators.validateFormControl(prevState.defaultconfiguration[configurationIndex][name], value)
            } else {
                prevState.defaultconfiguration[configurationIndex][name] = value;
            }

            return { ...prevState };
        });
    };
    const validateSummary = (calback, param) => {
        let validData = Validators.validateAssessmentSummary(summaryList)
        if (!validData?.formValid) {
            setSummaryData(prevState => {
                return { ...validData?.summary[summaryIndex] };
            })

        } else {
            calback(param)
        }
    }

    const addDefaultConfiguration = () => {
        setSummaryData(prevState => {
            prevState.defaultconfiguration.push(getDefaultConfigurationData('', '', '', '', ''));
            return { ...prevState };
        })
    };

    const deleteDefaultConfiguration = (configurationIndex) => {
        setSummaryData(prevState => {
            prevState.defaultconfiguration.splice(configurationIndex, 1);
            return { ...prevState };
        })
    };

    const addKpi = () => {
        setSummaryData(prevState => {
            prevState.kpi.push(getDefaultKpiData(''));
            return { ...prevState };
        })
    };

    const addKpiConfiguration = (kpiIndex) => {
        setSummaryData(prevState => {
            prevState.kpi[kpiIndex].configuration.push(getDefaultKpiConfigurationData('', '', '', ''));
            return { ...prevState };
        })
    };

    const deleteKpiConfiguration = (kpiIndex, configurationIndex) => {
        setSummaryData(prevState => {
            prevState.kpi[kpiIndex].configuration.splice(configurationIndex, 1);
            return { ...prevState };
        })
    };

    return (
        <div className="d-flex flex-column gap-3 p-2">
            <div className="d-flex">
                <Form.Label className="d-flex w-20 fw-bold align-items-center m-0">Summary Name</Form.Label>
                <TextInput name={'summaryname'} placeholder={'Summary Name'} value={summaryData.summaryname?.value || ''}
                    onChange={(event) => { onChangeSummaryData(event.target.name, event.target.value); }} ignoreDefaultErrorSpace
                    error={summaryData.summaryname?.error} />
            </div>
            <div className="d-flex">
                <Form.Label className='w-20 fw-bold align-items-center m-0'>Based On</Form.Label>
                <Form className="d-flex align-items-center gap-3">
                    {
                        (summaryData.isdefaultsummary ? scoringCreditForDefaultSummary : scoringCredit).map((option) => (
                            <Form.Check type="radio" name={"overall-based-on"} id={"overall-based-on-" + option.id} label={option.value} value={option.id} defaultChecked={summaryData.basedon?.value ? summaryData.basedon?.value == option.id : false} onChange={(event) => { onChangeSummaryData('basedon', event.target.value); }} />
                        ))
                    }
                    {summaryData.basedon?.error && <div className="text-danger text-s" style={{ minHeight: '18px' }}>{summaryData.basedon.error ? summaryData.basedon.error : ''}</div>}
                </Form>
            </div>
            {
                summaryData.isdefaultsummary ?
                    <div className="default-config d-flex flex-column gap-1">
                        <Form.Label className='d-flex align-items-center fw-bold m-0'>Configuration</Form.Label>
                        <div className="d-flex flex-column gap-3" style={{ backgroundColor: '#f0f0f0', padding: '1rem' }}>
                            {
                                summaryData?.defaultconfiguration?.map((configuration, configurationIndex) => (
                                    <div className="d-flex flex-column gap-2" key={`default-configuration-${configurationIndex}`}>
                                        <div className="d-flex gap-3">
                                            <Form.Label className='fw-bold d-flex align-items-center m-0'>If overall {scoringCreditForDefaultSummary.find(elem => { return elem.id == summaryData.basedon?.value })?.value?.toLowerCase()} is</Form.Label>
                                            <DropdownInput name='operator' defaultValue={'Select Operator'} value={configuration.operator?.value} options={operatorsWithNames} style={{ flex: '2 0' }}
                                                onChange={(value) => { onChangeDefaultSummaryConfigurationData('operator', value, configurationIndex); }}
                                                error={configuration.operator?.error}
                                            />
                                            <TextInput name={'scoremin'} type="text" placeholder={`Score ${configuration.operator?.value === '<>' ? 'Min' : ''}`} value={configuration.scoremin?.value} style={{ flex: '1 0' }}
                                                onChange={(event) => { onChangeDefaultSummaryConfigurationData(event.target.name, event.target.value, configurationIndex); }} ignoreDefaultErrorSpace
                                                error={configuration.scoremin?.error} />
                                            {
                                                configuration.operator?.value === '<>' ?
                                                    <>
                                                        <div className="d-flex align-items-center">and</div>
                                                        <TextInput name={'scoremax'} type="text" placeholder={`Score ${configuration.operator?.value === '<>' ? 'Max' : ''}`} value={configuration.scoremax?.value} style={{ flex: '1 0' }}
                                                            onChange={(event) => { onChangeDefaultSummaryConfigurationData(event.target.name, event.target.value, configurationIndex); }} ignoreDefaultErrorSpace
                                                            error={configuration.scoremax?.error} />
                                                    </> : null
                                            }
                                            <div className="config-delete">
                                                <img className={summaryData.defaultconfiguration.length > 1 ? '' : 'disabled'} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} onClick={summaryData.defaultconfiguration.length > 1 ? () => { deleteDefaultConfiguration(configurationIndex); } : null} />
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <Form.Label className=' pe-4 fw-bold d-flex align-items-center m-0'>Indicator Name</Form.Label>
                                            <TextInput name={'indicatorname'} placeholder={'Indicator Name'} value={configuration.indicatorname?.value || ''}
                                                onChange={(event) => { onChangeDefaultSummaryConfigurationData(event.target.name, event.target.value, configurationIndex); }} ignoreDefaultErrorSpace
                                                error={configuration.indicatorname?.error} />
                                        </div>
                                        <TextAreaInput style={{ "minHeight": "5rem" }} name={'description'} placeholder={'Description'} value={configuration.description?.value} onChange={(event) => { onChangeDefaultSummaryConfigurationData(event.target.name, event.target.value, configurationIndex); }} ignoreDefaultErrorSpace
                                            error={configuration.description?.error} />
                                    </div>
                                ))
                            }
                        </div>
                        <div className="d-flex p-2 align-items-center justify-content-center">
                            <button type="button" className="btn btn-grey-light mx-2" onClick={() => { validateSummary(addDefaultConfiguration, "") }}>
                                <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                Configuration
                            </button>
                        </div>
                    </div> :
                    <>
                        <div className="d-flex">
                            <Form.Label className='w-20 fw-bold align-items-center m-0'>Questions</Form.Label>
                            <DropdownInputGroup multiple placeholder="Select Questions" data={summaryData.questions} onChange={(data) => { onChangeSummaryData('questions', data); }} isHTMLCont={true} />
                        </div>
                        <div className="d-flex flex-column gap-3">
                            <div className="d-flex justify-content-between">
                                <Form.Label className='fw-bold d-flex align-items-center m-0'>Key Performance Indicator</Form.Label>
                                <button className="btn btn-white" onClick={() => { validateSummary(addKpi, "") }}>
                                    <img className="mx-1" width="12px" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                    <div>KPI</div>
                                </button>
                            </div>
                            {
                                summaryData.kpi?.map((kpi, kpiIndex) => (
                                    <div className="kpi d-flex flex-column gap-2" key={'kpi-' + kpiIndex}>
                                        <div className="d-flex">
                                            <Form.Label className='w-20 fw-bold d-flex align-items-center m-0'>Indicator Name</Form.Label>
                                            <TextInput name={'indicatorname'} placeholder={'Indicator Name'} value={kpi.indicatorname?.value || ''}
                                                onChange={(event) => { onChangeSummaryData(event.target.name, event.target.value, kpiIndex); }} ignoreDefaultErrorSpace
                                                error={kpi.indicatorname?.error} />
                                        </div>
                                        <div className="d-flex flex-column gap-1">
                                            <Form.Label className='d-flex align-items-center fw-bold m-0'>Configuration</Form.Label>
                                            <div className="d-flex flex-column gap-3" style={{ backgroundColor: '#f0f0f0', padding: '10px 20px' }}>
                                                {
                                                    kpi.configuration?.map((configuration, configurationIndex) => (
                                                        <div className="d-flex gap-3" key={`kpi-${kpiIndex}-configuration-${configurationIndex}`}>
                                                            <Form.Label className='w-20 fw-bold d-flex align-items-center m-0'>If {scoringCredit.find(elem => { return elem.id == summaryData.basedon?.value })?.value?.toLowerCase()} is</Form.Label>
                                                            <DropdownInput name='operator' defaultValue={'Select Operator'} value={configuration.operator?.value} options={operatorsWithNames} style={{ flex: '2 0' }}
                                                                onChange={(value) => { onChangeSummaryData('operator', value, kpiIndex, configurationIndex); }}
                                                                error={configuration.operator?.error}
                                                            />
                                                            <TextInput name={'scoremin'} type="text" placeholder={`Score ${configuration.operator?.value === '<>' ? 'Min' : ''}`} value={configuration.scoremin?.value} style={{ flex: '1 0' }}
                                                                onChange={(event) => { onChangeSummaryData(event.target.name, event.target.value, kpiIndex, configurationIndex); }} ignoreDefaultErrorSpace
                                                                error={configuration.scoremin?.error} />
                                                            {
                                                                configuration.operator?.value === '<>' ?
                                                                    <>
                                                                        <div className="d-flex align-items-center">and</div>
                                                                        <TextInput name={'scoremax'} type="text" placeholder={`Score ${configuration.operator?.value === '<>' ? 'Max' : ''}`} value={configuration.scoremax?.value} style={{ flex: '1 0' }}
                                                                            onChange={(event) => { onChangeSummaryData(event.target.name, event.target.value, kpiIndex, configurationIndex); }} ignoreDefaultErrorSpace
                                                                            error={configuration.scoremax?.error} />
                                                                    </> : null
                                                            }
                                                            <TextInput name={'displayname'} placeholder={'Display Name'} value={configuration.displayname?.value} style={{ flex: '3 0' }} error={configuration.displayname?.error}
                                                                onChange={(event) => { onChangeSummaryData(event.target.name, event.target.value, kpiIndex, configurationIndex); }} ignoreDefaultErrorSpace />
                                                            <TextInput type='color' name={'color'} placeholder={'Color'} value={configuration.color?.value} style={{ flex: '1 0' }} error={configuration.color?.error}
                                                                onChange={(event) => { onChangeSummaryData(event.target.name, event.target.value, kpiIndex, configurationIndex); }} ignoreDefaultErrorSpace />
                                                            <div className="kpi-config-delete">
                                                                <img className={kpi.configuration.length > 1 ? '' : 'disabled'} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/delete.png`} onClick={kpi.configuration.length > 1 ? () => { deleteKpiConfiguration(kpiIndex, configurationIndex); } : null} />
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className="d-flex p-2 align-items-center justify-content-center">
                                                <button type="button" className="btn btn-grey-light mx-2" onClick={() => { validateSummary(addKpiConfiguration, kpiIndex) }}>
                                                    <img width="15px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/plusb.png`} alt="plusb" />
                                                    Configuration
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>
            }
        </div>
    );
};

export const RenderQuestionView = ({ assessmentData, sectionIndex, questionIndex, onAction, printview = false }) => {
    const quillRef = useRef([]);
    const QUESTION_TYPE = {
        MULTICHOICE: 1,
        TRUEORFALSE: 2,
        DESCRIPTIVE: 3,
        RATING: 4,
        REORDER: 5
    };
    const [questionData, setQuestionData] = useState({});

    useEffect(() => {
        if (assessmentData?.sections?.[sectionIndex]?.questions?.[questionIndex]) {
            let question = assessmentData.sections[sectionIndex].questions[questionIndex];
            setQuestionData({ ...question });
        }
    }, [sectionIndex, questionIndex]);



    const renderAnswer = (questionData) => {
        switch (questionData.questiontype) {
            case QUESTION_TYPE.DESCRIPTIVE:
                return (
                    <div className="py-4 gap-3">
                        {!printview && <ReactQuill theme="snow"
                            modules={{
                                toolbar: [
                                    // [{ size: [] }, { 'font': [] }, { 'header': [1, 2, 3, 4, 5, 6, false] }],
                                    [{ 'color': [] }, { 'background': [] }],
                                    ['bold', 'italic', 'underline'],
                                    ['strike', 'blockquote', 'code-block'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
                                ],
                                clipboard: {
                                    matchVisual: false,
                                }
                            }}
                            placeholder={"Answer"} />}
                    </div>
                )
            case QUESTION_TYPE.MULTICHOICE:
                return (
                    <div className="d-flex flex-wrap gap-3" style={{ padding: "1rem 1.2rem" }}>
                        <div></div>
                        {questionData.options.map((item) => (
                            <Form.Check key={"checkbox-" + item.id} type="checkbox" label={`${item.optionname?.value}`} id={item.id} />
                        ))}
                    </div>
                )
            case QUESTION_TYPE.TRUEORFALSE:
                return (
                    <div className="d-flex flex-wrap gap-3" style={{ padding: "1rem 1.2rem" }}>
                        {questionData.options.map((item) => (
                            <Form.Check key={"radio-" + item.id} type="radio" name={"question-" + questionData.id} label={item.optionname?.value} id={item.id} />
                        ))}
                    </div>
                )
            case QUESTION_TYPE.REORDER:
                return (
                    <Draggable className="d-flex flex-wrap my-2 flex-column" >
                        {questionData?.options?.map((item, index) => (
                            <div className="my-1 d-flex justify-content-between p-2 border bprder-1">
                                <label>{item?.optionname?.value}</label>
                            </div>
                        ))}
                    </Draggable>
                )
            case QUESTION_TYPE.RATING:
                return (
                    <div className="px-3 py-4">
                        <Rating name="size-large" precision={0.5}
                            icon={<StarIcon fontSize="large" />}
                            emptyIcon={<StarIcon fontSize="large" />} />
                    </div>
                )
            default:
                break;
        }
    }
    if (printview) {
        return (
            <>
                <div  >
                    {assessmentData.questions.map((question, qindex) => (
                        <div className="border-bottom my-2" >
                            {/** Question Title */}
                            <div className="d-flex gap-3">
                                <div>{qindex + 1}</div>
                                <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: questionData?.questionname }} />
                            </div>

                            {/** For rendering answer */}
                            {renderAnswer(question)}
                        </div>
                    ))}
                </div>

            </>
        )
    }
    return (
        <div>
            {/** Question Title */}
            <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden" }} className="border-bottom" dangerouslySetInnerHTML={{ __html: questionData?.questionname }} />

            {/** For rendering answer */}
            <div key={questionData?.questionname}>
            {renderAnswer(questionData)}
            </div>

            {<div className="d-flex justify-content-between mt-2">
                <Button className="btn btn-primary" onClick={() => { onAction("Previous"); }}>Previous</Button>
                <div className="d-flex gap-3">
                    <Button className={`btn btn-primary`} onClick={() => { onAction("Next"); }}>Next</Button>
                </div>
            </div>}
            </div>
    )
}